<script setup lang="ts">
defineProps<{
    icon: string;
}>();
const emit = defineEmits<(e: "click", event: MouseEvent) => void>();
</script>
<template>
    <div :class="`${icon} NewIcon`" @click="emit('click', $event)">
        <template v-if="icon === 'design-system-academic-cap'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 18.8487L29 11.6265L16 4.4043L3 11.6265L16 18.8487ZM16 18.8487L24.8965 13.9062C25.6803 15.8827 26.1111 18.0376 26.1111 20.2931C26.1111 21.3061 26.0242 22.2988 25.8575 23.2642C22.0873 23.6308 18.6708 25.2052 16 27.5956C13.3292 25.2052 9.9127 23.6308 6.14256 23.2642C5.9758 22.2988 5.88889 21.3061 5.88889 20.293C5.88889 18.0375 6.31969 15.8827 7.10349 13.9062L16 18.8487ZM10.2222 27.5153V16.6821L16 13.4722"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-archive'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 10.2221H26.1111M5.88889 10.2221C4.2934 10.2221 3 8.92871 3 7.33322C3 5.73774 4.2934 4.44434 5.88889 4.44434H26.1111C27.7066 4.44434 29 5.73774 29 7.33322C29 8.92871 27.7066 10.2221 26.1111 10.2221M5.88889 10.2221L5.88889 24.6666C5.88889 26.262 7.18229 27.5554 8.77778 27.5554H23.2222C24.8177 27.5554 26.1111 26.262 26.1111 24.6666V10.2221M13.1111 15.9999H18.8889"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 17.4444L16 21.7778M16 21.7778L11.6667 17.4444M16 21.7778L16 10.2222M16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 11.6667L21.7778 16M21.7778 16L17.4444 20.3333M21.7778 16L10.2222 16M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 20.3333L10.2222 16M10.2222 16L14.5556 11.6667M10.2222 16L21.7778 16M3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 18.8889L16 29M16 29L5.88892 18.8889M16 29L16 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 14.5556L16 10.2222M16 10.2222L20.3333 14.5556M16 10.2222L16 21.7778M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-annotation'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 10.2222H23.2222M8.77778 16H14.5556M16 27.5556L10.2222 21.7778H5.88889C4.2934 21.7778 3 20.4844 3 18.8889V7.33335C3 5.73786 4.2934 4.44446 5.88889 4.44446H26.1111C27.7066 4.44446 29 5.73786 29 7.33335V18.8889C29 20.4844 27.7066 21.7778 26.1111 21.7778H21.7778L16 27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 26.1111L3 16M3 16L13.1111 5.88892M3 16L29 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 21.7777L3 15.9999M3 15.9999L8.77778 10.2222M3 15.9999L29 15.9999"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 10.2222L29 15.9999M29 15.9999L23.2222 21.7777M29 15.9999L3 15.9999"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 23.2222L15.9999 29M15.9999 29L10.2222 23.2222M15.9999 29L15.9999 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-adjustments-vertical'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6.25V3M16 6.25C14.2051 6.25 12.75 7.70507 12.75 9.5C12.75 11.2949 14.2051 12.75 16 12.75M16 6.25C17.7949 6.25 19.25 7.70507 19.25 9.5C19.25 11.2949 17.7949 12.75 16 12.75M6.25 25.75C8.04493 25.75 9.5 24.2949 9.5 22.5C9.5 20.7051 8.04493 19.25 6.25 19.25M6.25 25.75C4.45507 25.75 3 24.2949 3 22.5C3 20.7051 4.45507 19.25 6.25 19.25M6.25 25.75V29M6.25 19.25V3M16 12.75V29M25.75 25.75C27.5449 25.75 29 24.2949 29 22.5C29 20.7051 27.5449 19.25 25.75 19.25M25.75 25.75C23.9551 25.75 22.5 24.2949 22.5 22.5C22.5 20.7051 23.9551 19.25 25.75 19.25M25.75 25.75V29M25.75 19.25V3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-adjustments-horizontal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M25.75 16L29 16M25.75 16C25.75 14.2051 24.2949 12.75 22.5 12.75C20.7051 12.75 19.25 14.2051 19.25 16M25.75 16C25.75 17.7949 24.2949 19.25 22.5 19.25C20.7051 19.25 19.25 17.7949 19.25 16M6.25 6.25C6.25 8.04492 7.70507 9.5 9.5 9.5C11.2949 9.5 12.75 8.04492 12.75 6.25M6.25 6.25C6.25 4.45507 7.70507 3 9.5 3C11.2949 3 12.75 4.45507 12.75 6.25M6.25 6.25L3 6.25M12.75 6.25L29 6.25M19.25 16L3 16M6.25 25.75C6.25 27.5449 7.70507 29 9.5 29C11.2949 29 12.75 27.5449 12.75 25.75M6.25 25.75C6.25 23.9551 7.70507 22.5 9.5 22.5C11.2949 22.5 12.75 23.9551 12.75 25.75M6.25 25.75L3 25.75M12.75 25.75L29 25.75"
                    stroke="#111827"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 8.77778L15.9999 3M15.9999 3L21.7777 8.77778M15.9999 3V29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8889 5.88892L29 16M29 16L18.8889 26.1111M29 16L3 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.8333 26.8333L3 16M3 16L13.8333 5.16663M3 16L29 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88892 13.1111L16 3M16 3L26.1111 13.1111M16 3V29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.1667 5.16663L29 16M29 16L18.1667 26.8333M29 16L3 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-ajout_intérimaire'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1477_136679)">
                    <path
                        d="M27.9173 14.9165H25.7507V12.7498C25.7507 12.4625 25.6365 12.187 25.4334 11.9838C25.2302 11.7806 24.9546 11.6665 24.6673 11.6665C24.38 11.6665 24.1044 11.7806 23.9013 11.9838C23.6981 12.187 23.584 12.4625 23.584 12.7498V14.9165H21.4173C21.13 14.9165 20.8544 15.0306 20.6513 15.2338C20.4481 15.437 20.334 15.7125 20.334 15.9998C20.334 16.2872 20.4481 16.5627 20.6513 16.7659C20.8544 16.969 21.13 17.0832 21.4173 17.0832H23.584V19.2498C23.584 19.5372 23.6981 19.8127 23.9013 20.0159C24.1044 20.219 24.38 20.3332 24.6673 20.3332C24.9546 20.3332 25.2302 20.219 25.4334 20.0159C25.6365 19.8127 25.7507 19.5372 25.7507 19.2498V17.0832H27.9173C28.2046 17.0832 28.4802 16.969 28.6834 16.7659C28.8865 16.5627 29.0007 16.2872 29.0007 15.9998C29.0007 15.7125 28.8865 15.437 28.6834 15.2338C28.4802 15.0306 28.2046 14.9165 27.9173 14.9165Z"
                        fill="#111827"
                    />
                    <path
                        d="M12.75 16C14.0356 16 15.2923 15.6188 16.3612 14.9046C17.4301 14.1903 18.2632 13.1752 18.7552 11.9874C19.2472 10.7997 19.3759 9.49279 19.1251 8.23191C18.8743 6.97104 18.2552 5.81285 17.3462 4.90381C16.4371 3.99477 15.279 3.3757 14.0181 3.1249C12.7572 2.87409 11.4503 3.00282 10.2626 3.49479C9.07484 3.98676 8.05968 4.81988 7.34545 5.8888C6.63122 6.95771 6.25 8.21442 6.25 9.5C6.25172 11.2234 6.93709 12.8757 8.15571 14.0943C9.37432 15.3129 11.0266 15.9983 12.75 16ZM12.75 5.16667C13.607 5.16667 14.4449 5.42081 15.1575 5.89697C15.8701 6.37312 16.4255 7.04989 16.7535 7.84171C17.0815 8.63352 17.1673 9.50481 17.0001 10.3454C16.8329 11.186 16.4202 11.9581 15.8141 12.5641C15.2081 13.1702 14.436 13.5829 13.5954 13.7501C12.7548 13.9173 11.8835 13.8315 11.0917 13.5035C10.2999 13.1755 9.62312 12.6201 9.14696 11.9075C8.67081 11.1949 8.41667 10.3571 8.41667 9.5C8.41667 8.35073 8.87321 7.24853 9.68587 6.43587C10.4985 5.62321 11.6007 5.16667 12.75 5.16667Z"
                        fill="#111827"
                    />
                    <path
                        d="M12.75 18.1667C10.165 18.1695 7.68673 19.1977 5.85888 21.0255C4.03102 22.8534 3.00287 25.3317 3 27.9167C3 28.204 3.11414 28.4795 3.3173 28.6827C3.52047 28.8859 3.79602 29 4.08333 29C4.37065 29 4.6462 28.8859 4.84937 28.6827C5.05253 28.4795 5.16667 28.204 5.16667 27.9167C5.16667 25.9054 5.96562 23.9766 7.38777 22.5544C8.80992 21.1323 10.7388 20.3333 12.75 20.3333C14.7612 20.3333 16.6901 21.1323 18.1122 22.5544C19.5344 23.9766 20.3333 25.9054 20.3333 27.9167C20.3333 28.204 20.4475 28.4795 20.6506 28.6827C20.8538 28.8859 21.1293 29 21.4167 29C21.704 29 21.9795 28.8859 22.1827 28.6827C22.3859 28.4795 22.5 28.204 22.5 27.9167C22.4971 25.3317 21.469 22.8534 19.6411 21.0255C17.8133 19.1977 15.335 18.1695 12.75 18.1667Z"
                        fill="#111827"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1477_136679">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrows-expand'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 9.5V3M3 3H9.5M3 3L11.125 11.125M29 9.5V3M29 3H22.5M29 3L20.875 11.125M3 22.5V29M3 29H9.5M3 29L11.125 20.875M29 29L20.875 20.875M29 29V22.5M29 29H22.5"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-ban'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M25.1924 25.1924C30.2692 20.1156 30.2692 11.8844 25.1924 6.80761C20.1156 1.7308 11.8844 1.7308 6.80761 6.80761M25.1924 25.1924C20.1156 30.2692 11.8844 30.2692 6.80761 25.1924C1.7308 20.1156 1.7308 11.8844 6.80761 6.80761M25.1924 25.1924L6.80761 6.80761"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-bell'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3332 23.2222H27.5554L25.5261 21.1929C24.9757 20.6425 24.6666 19.8961 24.6666 19.1178V14.5556C24.6666 10.782 22.2549 7.57179 18.8888 6.38204V5.88889C18.8888 4.2934 17.5954 3 15.9999 3C14.4044 3 13.111 4.2934 13.111 5.88889V6.38204C9.74489 7.57179 7.33322 10.782 7.33322 14.5556V19.1178C7.33322 19.8961 7.02404 20.6425 6.47368 21.1929L4.44434 23.2222H11.6666M20.3332 23.2222V24.6667C20.3332 27.0599 18.3931 29 15.9999 29C13.6067 29 11.6666 27.0599 11.6666 24.6667V23.2222M20.3332 23.2222H11.6666"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-book-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7.51587V26.2936M16 7.51587C14.313 6.3951 12.0227 5.7063 9.5 5.7063C6.97729 5.7063 4.68696 6.3951 3 7.51587V26.2936C4.68696 25.1729 6.97729 24.4841 9.5 24.4841C12.0227 24.4841 14.313 25.1729 16 26.2936M16 7.51587C17.687 6.3951 19.9773 5.7063 22.5 5.7063C25.0227 5.7063 27.313 6.3951 29 7.51587V26.2936C27.313 25.1729 25.0227 24.4841 22.5 24.4841C19.9773 24.4841 17.687 25.1729 16 26.2936"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-bookmark-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 3V22.5L16 19.25L9.5 22.5V3M6.25 29H25.75C27.5449 29 29 27.5449 29 25.75V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-backspace'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 18.8889L18.8889 16M18.8889 16L21.7778 13.1111M18.8889 16L16 13.1111M18.8889 16L21.7778 18.8889M3 16L12.265 25.265C12.8067 25.8068 13.5415 26.1111 14.3077 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H14.3077C13.5415 5.88892 12.8067 6.19328 12.265 6.73505L3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-at-symbol'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7772 15.9989C21.7772 12.8082 19.1906 10.2216 15.9999 10.2216C12.8092 10.2216 10.2226 12.8082 10.2226 15.9989C10.2226 19.1896 12.8092 21.7762 15.9999 21.7762C19.1906 21.7762 21.7772 19.1896 21.7772 15.9989ZM21.7772 15.9989V18.1654C21.7772 20.1596 23.3938 21.7762 25.388 21.7762C27.3822 21.7762 28.9988 20.1596 28.9988 18.1654V15.9989C28.9988 8.81981 23.179 3 15.9999 3C8.82079 3 3.00098 8.81981 3.00098 15.9989C3.00098 23.178 8.82079 28.9978 15.9999 28.9978M22.4993 27.2563C20.4485 28.4404 18.2091 29.0021 15.9998 29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-briefcase'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 19.2578C24.9855 20.8829 20.5972 21.7778 16 21.7778C11.4028 21.7778 7.01454 20.8829 3 19.2578M21.7778 8.77778V5.88889C21.7778 4.2934 20.4844 3 18.8889 3H13.1111C11.5156 3 10.2222 4.2934 10.2222 5.88889V8.77778M16 17.4444H16.0144M5.88889 29H26.1111C27.7066 29 29 27.7066 29 26.1111V11.6667C29 10.0712 27.7066 8.77778 26.1111 8.77778H5.88889C4.2934 8.77778 3 10.0712 3 11.6667V26.1111C3 27.7066 4.2934 29 5.88889 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-bookmark'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88892 5.88889C5.88892 4.2934 7.18232 3 8.7778 3H23.2222C24.8177 3 26.1111 4.2934 26.1111 5.88889V29L16 23.9444L5.88892 29V5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cake'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 21.1218C28.2447 21.1218 27.4893 21.3404 26.8333 21.7778C25.5213 22.6525 23.812 22.6525 22.5 21.7778C21.188 20.9031 19.4787 20.9031 18.1667 21.7778C16.8546 22.6525 15.1454 22.6525 13.8333 21.7778C12.5213 20.9031 10.812 20.9031 9.5 21.7778C8.18797 22.6525 6.47869 22.6525 5.16667 21.7778C4.51065 21.3404 3.75533 21.1218 3 21.1218M11.6667 7.33333V10.2222M16 7.33333V10.2222M20.3333 7.33333V10.2222M11.6667 3H11.6811M16 3H16.0144M20.3333 3H20.3478M29 29V18.8889C29 17.2934 27.7066 16 26.1111 16H5.88889C4.2934 16 3 17.2934 3 18.8889V29H29ZM24.6667 16V13.1111C24.6667 11.5156 23.3733 10.2222 21.7778 10.2222H10.2222C8.62673 10.2222 7.33333 11.5156 7.33333 13.1111V16H24.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-beaker'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.5243 20.857C26.1287 20.4615 25.6249 20.1918 25.0763 20.0821L21.6937 19.4056C19.84 19.0348 17.9156 19.2925 16.2248 20.1379L15.7752 20.3628C14.0844 21.2082 12.16 21.4659 10.3063 21.0952L7.56942 20.5478C6.6404 20.362 5.67998 20.6528 5.01005 21.3227M10.3328 4.66553H21.6672L20.2504 6.08233V13.4094C20.2504 14.161 20.549 14.8817 21.0804 15.4131L28.1644 22.4971C29.9495 24.2822 28.6852 27.3344 26.1607 27.3344H5.83929C3.31481 27.3344 2.05055 24.2822 3.83563 22.4971L10.9196 15.4131C11.451 14.8817 11.7496 14.161 11.7496 13.4094V6.08233L10.3328 4.66553Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-calculator'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 8.77778H20.3334M20.3334 23.2222V18.8889M16 23.2222H16.0145M11.6667 23.2222H11.6811M11.6667 18.8889H11.6811M16 18.8889H16.0145M20.3334 14.5556H20.3478M16 14.5556H16.0145M11.6667 14.5556H11.6811M8.77781 29H23.2223C24.8177 29 26.1111 27.7066 26.1111 26.1111V5.88889C26.1111 4.2934 24.8177 3 23.2223 3H8.77781C7.18232 3 5.88892 4.2934 5.88892 5.88889V26.1111C5.88892 27.7066 7.18232 29 8.77781 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chart-bar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 26.1111V17.4444C11.6667 15.849 10.3733 14.5556 8.77778 14.5556H5.88889C4.2934 14.5556 3 15.849 3 17.4444V26.1111C3 27.7066 4.2934 29 5.88889 29H8.77778C10.3733 29 11.6667 27.7066 11.6667 26.1111ZM11.6667 26.1111V11.6667C11.6667 10.0712 12.9601 8.77778 14.5556 8.77778H17.4444C19.0399 8.77778 20.3333 10.0712 20.3333 11.6667V26.1111M11.6667 26.1111C11.6667 27.7066 12.9601 29 14.5556 29H17.4444C19.0399 29 20.3333 27.7066 20.3333 26.1111M20.3333 26.1111V5.88889C20.3333 4.2934 21.6267 3 23.2222 3H26.1111C27.7066 3 29 4.2934 29 5.88889V26.1111C29 27.7066 27.7066 29 26.1111 29H23.2222C21.6267 29 20.3333 27.7066 20.3333 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-camera'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 11.6666C3 10.0711 4.2934 8.77767 5.88889 8.77767H7.23169C8.1976 8.77767 9.0996 8.29493 9.63539 7.49125L10.8091 5.73076C11.3448 4.92707 12.2468 4.44434 13.2128 4.44434H18.7872C19.7532 4.44434 20.6552 4.92707 21.1909 5.73076L22.3646 7.49125C22.9004 8.29493 23.8024 8.77767 24.7683 8.77767H26.1111C27.7066 8.77767 29 10.0711 29 11.6666V24.6666C29 26.262 27.7066 27.5554 26.1111 27.5554H5.88889C4.2934 27.5554 3 26.262 3 24.6666V11.6666Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.3333 17.4443C20.3333 19.8376 18.3932 21.7777 16 21.7777C13.6068 21.7777 11.6667 19.8376 11.6667 17.4443C11.6667 15.0511 13.6068 13.111 16 13.111C18.3932 13.111 20.3333 15.0511 20.3333 17.4443Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cash'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 11.6667V8.7778C23.2222 7.18232 21.9288 5.88892 20.3333 5.88892H5.88889C4.2934 5.88892 3 7.18232 3 8.7778V17.4445C3 19.04 4.2934 20.3334 5.88889 20.3334H8.77778M11.6667 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V14.5556C29 12.9601 27.7066 11.6667 26.1111 11.6667H11.6667C10.0712 11.6667 8.77778 12.9601 8.77778 14.5556V23.2222C8.77778 24.8177 10.0712 26.1111 11.6667 26.1111ZM21.7778 18.8889C21.7778 20.4844 20.4844 21.7778 18.8889 21.7778C17.2934 21.7778 16 20.4844 16 18.8889C16 17.2934 17.2934 16 18.8889 16C20.4844 16 21.7778 17.2934 21.7778 18.8889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chart-pie'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5909 3C8.0711 3.72073 3 9.24826 3 15.9602C3 23.1619 8.83811 29 16.0398 29C22.7517 29 28.2793 23.9289 29 17.4091H14.5909V3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.3375 11.6136H20.3864V3.66267C24.0914 4.9722 27.0279 7.90864 28.3375 11.6136Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chart-square-bar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 9.5V22.5M16 14.375V22.5M9.5 19.25V22.5M6.25 29H25.75C27.5449 29 29 27.5449 29 25.75V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-calendar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 8.77778V3M21.7778 8.77778V3M8.77778 14.5556H23.2222M5.88889 29H26.1111C27.7066 29 29 27.7066 29 26.1111V8.77778C29 7.18229 27.7066 5.88889 26.1111 5.88889H5.88889C4.2934 5.88889 3 7.18229 3 8.77778V26.1111C3 27.7066 4.2934 29 5.88889 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chat-alt-2'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 8.77778H26.1111C27.7066 8.77778 29 10.0712 29 11.6667V20.3333C29 21.9288 27.7066 23.2222 26.1111 23.2222H23.2222V29L17.4444 23.2222H11.6667C10.8689 23.2222 10.1467 22.8989 9.62391 22.3761M9.62391 22.3761L14.5556 17.4444H20.3333C21.9288 17.4444 23.2222 16.151 23.2222 14.5556V5.88889C23.2222 4.2934 21.9288 3 20.3333 3H5.88889C4.2934 3 3 4.2934 3 5.88889V14.5556C3 16.151 4.2934 17.4444 5.88889 17.4444H8.77778V23.2222L9.62391 22.3761Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chat-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 12.3888H10.2367M16 12.3888H16.0144M21.7778 12.3888H21.7922M11.6667 21.0555H5.88889C4.2934 21.0555 3 19.7621 3 18.1666V6.61106C3 5.01557 4.2934 3.72217 5.88889 3.72217H26.1111C27.7066 3.72217 29 5.01557 29 6.61106V18.1666C29 19.7621 27.7066 21.0555 26.1111 21.0555H18.8889L11.6667 28.2777V21.0555Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chat'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 16H10.2367M16 16H16.0144M21.7778 16H21.7922M29 16C29 22.382 23.1797 27.5556 16 27.5556C13.7766 27.5556 11.6836 27.0594 9.85341 26.1849L3 27.5556L5.01498 22.1823C3.73893 20.3945 3 18.274 3 16C3 9.61806 8.8203 4.44446 16 4.44446C23.1797 4.44446 29 9.61806 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-check-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 16L14.5556 18.8889L20.3333 13.1111M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 17.8572L10.4286 25.2858L29 6.71436" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.5 29L9.5 16L22.5 3" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 9.5L16 22.5L3 9.5" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.8334 18.1667L16.0001 29M16.0001 29L5.16675 18.1667M16.0001 29L16.0001 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 22.5L16 9.5L3 22.5" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M27 16.8L16 28L5 16.8M27 4L16 15.2L5 4"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15.2L16 4L27 15.2M5 28L16 16.8L27 28"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.8 5L28 16L16.8 27M4 5L15.2 16L4 27"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chip'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 3V5.88889M20.3333 3V5.88889M11.6667 26.1111V29M20.3333 26.1111V29M5.88889 11.6667H3M5.88889 20.3333H3M29 11.6667H26.1111M29 20.3333H26.1111M8.77778 26.1111H23.2222C24.8177 26.1111 26.1111 24.8177 26.1111 23.2222V8.77778C26.1111 7.18229 24.8177 5.88889 23.2222 5.88889H8.77778C7.18229 5.88889 5.88889 7.18229 5.88889 8.77778V23.2222C5.88889 24.8177 7.18229 26.1111 8.77778 26.1111ZM11.6667 11.6667H20.3333V20.3333H11.6667V11.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.6107 17.9449C12.0893 17.4236 11.2441 17.4236 10.7227 17.9449C10.2014 18.4663 10.2014 19.3115 10.7227 19.8329L12.6107 17.9449ZM14.5556 21.7778L13.6116 22.7218C14.1329 23.2431 14.9782 23.2431 15.4996 22.7218L14.5556 21.7778ZM21.2773 16.944C21.7987 16.4226 21.7987 15.5774 21.2773 15.056C20.756 14.5347 19.9107 14.5347 19.3894 15.056L21.2773 16.944ZM24.7761 8.77778V26.1111H27.4461V8.77778H24.7761ZM23.2222 27.665H8.7778V30.335H23.2222V27.665ZM7.22392 26.1111V8.77778H4.55392V26.1111H7.22392ZM8.7778 7.22389H11.6667V4.55389H8.7778V7.22389ZM20.3334 7.22389H23.2222V4.55389H20.3334V7.22389ZM8.7778 27.665C7.91962 27.665 7.22392 26.9693 7.22392 26.1111H4.55392C4.55392 28.4439 6.44502 30.335 8.7778 30.335V27.665ZM24.7761 26.1111C24.7761 26.9693 24.0804 27.665 23.2222 27.665V30.335C25.555 30.335 27.4461 28.4439 27.4461 26.1111H24.7761ZM27.4461 8.77778C27.4461 6.44499 25.555 4.55389 23.2222 4.55389V7.22389C24.0804 7.22389 24.7761 7.91959 24.7761 8.77778H27.4461ZM7.22392 8.77778C7.22392 7.91959 7.91962 7.22389 8.7778 7.22389V4.55389C6.44502 4.55389 4.55392 6.44499 4.55392 8.77778H7.22392ZM10.7227 19.8329L13.6116 22.7218L15.4996 20.8338L12.6107 17.9449L10.7227 19.8329ZM15.4996 22.7218L21.2773 16.944L19.3894 15.056L13.6116 20.8338L15.4996 22.7218ZM14.5556 4.335H17.4445V1.665H14.5556V4.335ZM17.4445 7.44278H14.5556V10.1128H17.4445V7.44278ZM14.5556 7.44278C13.6974 7.44278 13.0017 6.74708 13.0017 5.88889H10.3317C10.3317 8.22168 12.2228 10.1128 14.5556 10.1128V7.44278ZM18.9984 5.88889C18.9984 6.74708 18.3027 7.44278 17.4445 7.44278V10.1128C19.7773 10.1128 21.6684 8.22168 21.6684 5.88889H18.9984ZM17.4445 4.335C18.3027 4.335 18.9984 5.0307 18.9984 5.88889H21.6684C21.6684 3.5561 19.7773 1.665 17.4445 1.665V4.335ZM14.5556 1.665C12.2228 1.665 10.3317 3.5561 10.3317 5.88889H13.0017C13.0017 5.0307 13.6974 4.335 14.5556 4.335V1.665Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard-copy'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2221 5.88889H7.33322C5.73774 5.88889 4.44434 7.18229 4.44434 8.77778V26.1111C4.44434 27.7066 5.73774 29 7.33322 29H21.7777C23.3732 29 24.6666 27.7066 24.6666 26.1111V24.6667M10.2221 5.88889C10.2221 7.48438 11.5155 8.77778 13.111 8.77778H15.9999C17.5954 8.77778 18.8888 7.48438 18.8888 5.88889M10.2221 5.88889C10.2221 4.2934 11.5155 3 13.111 3H15.9999C17.5954 3 18.8888 4.2934 18.8888 5.88889M18.8888 5.88889H21.7777C23.3732 5.88889 24.6666 7.18229 24.6666 8.77778V13.1111M27.5554 18.8889H13.111M13.111 18.8889L17.4443 14.5556M13.111 18.8889L17.4443 23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-badge-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6309 16L14.5436 18.9127L20.3691 13.0873M9.9339 5.3643C10.9789 5.28091 11.9709 4.86999 12.7688 4.19005C14.6307 2.60332 17.3693 2.60332 19.2312 4.19005C20.0291 4.86999 21.0211 5.28091 22.0661 5.3643C24.5047 5.5589 26.4411 7.49533 26.6357 9.9339C26.7191 10.9789 27.13 11.9709 27.81 12.7688C29.3967 14.6307 29.3967 17.3693 27.81 19.2312C27.13 20.0291 26.7191 21.0211 26.6357 22.0661C26.4411 24.5047 24.5047 26.4411 22.0661 26.6357C21.0211 26.7191 20.0291 27.13 19.2312 27.81C17.3693 29.3967 14.6307 29.3967 12.7688 27.81C11.9709 27.13 10.9789 26.7191 9.9339 26.6357C7.49533 26.4411 5.5589 24.5047 5.3643 22.0661C5.28091 21.0211 4.86999 20.0291 4.19005 19.2312C2.60332 17.3693 2.60332 14.6307 4.19005 12.7688C4.86999 11.9709 5.28091 10.9789 5.3643 9.9339C5.5589 7.49533 7.49533 5.5589 9.9339 5.3643Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cloud-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.50005 21.2C6.62817 21.2 4.30005 18.8719 4.30005 16C4.30005 13.5208 6.03498 11.4469 8.35697 10.926C8.25424 10.4671 8.20005 9.98989 8.20005 9.5C8.20005 5.91015 11.1102 3 14.7 3C17.8451 3 20.4685 5.23373 21.0703 8.20127C21.1134 8.20043 21.1567 8.2 21.2 8.2C24.7899 8.2 27.7001 11.1101 27.7001 14.7C27.7001 17.8446 25.467 20.4677 22.5 21.07M12.1 25.1L16 29M16 29L19.9 25.1M16 29V13.4"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clock'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10.2222V16L20.3333 20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cloud-upload'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.50005 21.2C6.62817 21.2 4.30005 18.8719 4.30005 16C4.30005 13.5208 6.03498 11.4469 8.35697 10.926C8.25424 10.4671 8.20005 9.98989 8.20005 9.5C8.20005 5.91015 11.1102 3 14.7 3C17.8451 3 20.4685 5.23373 21.0703 8.20127C21.1134 8.20043 21.1567 8.2 21.2 8.2C24.7899 8.2 27.7001 11.1101 27.7001 14.7C27.7001 17.8446 25.467 20.4677 22.5 21.07M19.9 17.3L16 13.4M16 13.4L12.1 17.3M16 13.4L16 29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.16675 13.8333L16.0001 3M16.0001 3L26.8334 13.8333M16.0001 3V29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard-list'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 5.88889H8.7778C7.18232 5.88889 5.88892 7.18229 5.88892 8.77778V26.1111C5.88892 27.7066 7.18232 29 8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V8.77778C26.1111 7.18229 24.8177 5.88889 23.2222 5.88889H20.3334M11.6667 5.88889C11.6667 7.48438 12.9601 8.77778 14.5556 8.77778H17.4445C19.04 8.77778 20.3334 7.48438 20.3334 5.88889M11.6667 5.88889C11.6667 4.2934 12.9601 3 14.5556 3H17.4445C19.04 3 20.3334 4.2934 20.3334 5.88889M16 16H20.3334M16 21.7778H20.3334M11.6667 16H11.6811M11.6667 21.7778H11.6811"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2 27L4 16L15.2 5M28 27L16.8 16L28 5"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-credit-card'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.1111H29M8.77778 20.3334H10.2222M16 20.3334H17.4444M7.33333 26.1111H24.6667C27.0599 26.1111 29 24.171 29 21.7778V10.2222C29 7.82902 27.0599 5.88892 24.6667 5.88892H7.33333C4.9401 5.88892 3 7.82902 3 10.2222V21.7778C3 24.171 4.9401 26.1111 7.33333 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-color-swatch'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 29C5.5868 29 3 26.4132 3 23.2222V5.88889C3 4.2934 4.2934 3 5.88889 3H11.6667C13.2622 3 14.5556 4.2934 14.5556 5.88889V23.2222C14.5556 26.4132 11.9688 29 8.77778 29ZM8.77778 29H26.1111C27.7066 29 29 27.7066 29 26.1111V20.3333C29 18.7378 27.7066 17.4444 26.1111 17.4444H22.7266M14.5556 9.2734L16.9488 6.8802C18.077 5.75202 19.9061 5.75202 21.0343 6.8802L25.1198 10.9657C26.248 12.0939 26.248 13.923 25.1198 15.0512L12.8633 27.3077M8.77778 23.2222H8.79222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cog'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.58 4.90278C14.1959 2.36574 17.8041 2.36574 18.42 4.90278C18.8179 6.54168 20.6955 7.31943 22.1357 6.44189C24.3652 5.08345 26.9165 7.63479 25.5581 9.86427C24.6806 11.3045 25.4583 13.1821 27.0972 13.58C29.6343 14.1959 29.6343 17.8041 27.0972 18.42C25.4583 18.8179 24.6806 20.6955 25.5581 22.1357C26.9165 24.3652 24.3652 26.9165 22.1357 25.5581C20.6955 24.6806 18.8179 25.4583 18.42 27.0972C17.8041 29.6343 14.1959 29.6343 13.58 27.0972C13.1821 25.4583 11.3045 24.6806 9.86427 25.5581C7.6348 26.9165 5.08345 24.3652 6.44189 22.1357C7.31943 20.6955 6.54168 18.8179 4.90278 18.42C2.36574 17.8041 2.36574 14.1959 4.90278 13.58C6.54168 13.1821 7.31943 11.3045 6.44189 9.86427C5.08345 7.63479 7.63479 5.08345 9.86427 6.44189C11.3045 7.31943 13.1821 6.54168 13.58 4.90278Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.3333 16C20.3333 18.3932 18.3932 20.3333 16 20.3333C13.6068 20.3333 11.6667 18.3932 11.6667 16C11.6667 13.6068 13.6068 11.6667 16 11.6667C18.3932 11.6667 20.3333 13.6068 20.3333 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-collection'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 14.5556H5.88889M26.1111 14.5556C27.7066 14.5556 29 15.849 29 17.4444V26.1111C29 27.7066 27.7066 29 26.1111 29H5.88889C4.2934 29 3 27.7066 3 26.1111V17.4444C3 15.849 4.2934 14.5556 5.88889 14.5556M26.1111 14.5556V11.6667C26.1111 10.0712 24.8177 8.77778 23.2222 8.77778M5.88889 14.5556V11.6667C5.88889 10.0712 7.18229 8.77778 8.77778 8.77778M8.77778 8.77778V5.88889C8.77778 4.2934 10.0712 3 11.6667 3H20.3333C21.9288 3 23.2222 4.2934 23.2222 5.88889V8.77778M8.77778 8.77778H23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cube-transparent'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8888 13.1111L15.9999 14.5556M15.9999 14.5556L13.111 13.1111M15.9999 14.5556V18.1667M27.5554 8.77778L24.6666 10.2222M27.5554 8.77778L24.6666 7.33333M27.5554 8.77778V12.3889M18.8888 4.44444L15.9999 3L13.111 4.44444M4.44434 8.77778L7.33322 7.33333M4.44434 8.77778L7.33322 10.2222M4.44434 8.77778V12.3889M15.9999 29L13.111 27.5556M15.9999 29L18.8888 27.5556M15.9999 29V25.3889M7.33322 24.6667L4.44434 23.2222V19.6111M24.6666 24.6667L27.5554 23.2222V19.6111"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cloud'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 20.3334C3 23.5243 5.5868 26.1111 8.77778 26.1111H21.7778C25.7665 26.1111 29 22.8776 29 18.8889C29 14.9002 25.7665 11.6667 21.7778 11.6667C21.7296 11.6667 21.6815 11.6672 21.6336 11.6681C20.965 8.37083 18.0501 5.88892 14.5556 5.88892C10.5668 5.88892 7.33333 9.12241 7.33333 13.1111C7.33333 13.6555 7.39355 14.1857 7.50769 14.6956C4.92771 15.2743 3 17.5787 3 20.3334Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-code'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.4 26.4L18.6 5.59998M23.8 10.8L29 16L23.8 21.2M8.2 21.2L3 16L8.2 10.8"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-rupee'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 10.2222H20.3333M13.1111 10.2222C15.5043 10.2222 17.4444 12.1623 17.4444 14.5556C17.4444 16.9488 15.5043 18.8889 13.1111 18.8889H11.6667L16 23.2222M11.6667 14.5556H20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cube'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M27.5554 8.77778L15.9999 3L4.44434 8.77778M27.5554 8.77778L15.9999 14.5556M27.5554 8.77778V23.2222L15.9999 29M15.9999 14.5556L4.44434 8.77778M15.9999 14.5556V29M4.44434 8.77778V23.2222L15.9999 29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-bangladeshi'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 14.5556V11.6667C14.5556 10.0712 13.2622 8.77778 11.6667 8.77778M14.5556 14.5556V20.3333C14.5556 21.9288 15.849 23.2222 17.4444 23.2222C19.0399 23.2222 20.3333 21.9288 20.3333 20.3333V18.8889M14.5556 14.5556H11.6667M14.5556 14.5556H20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-euro'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0641 21.1069C17.3719 23.9273 14.6281 23.9273 12.9359 21.1069C11.2436 18.2864 11.2436 13.7136 12.9359 10.8931C14.6281 8.07266 17.3719 8.07266 19.0641 10.8931M10.2222 13.8333H16M10.2222 18.1667H16M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 5.88889H8.7778C7.18232 5.88889 5.88892 7.18229 5.88892 8.77778V26.1111C5.88892 27.7066 7.18232 29 8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V8.77778C26.1111 7.18229 24.8177 5.88889 23.2222 5.88889H20.3334M11.6667 5.88889C11.6667 7.48438 12.9601 8.77778 14.5556 8.77778H17.4445C19.04 8.77778 20.3334 7.48438 20.3334 5.88889M11.6667 5.88889C11.6667 4.2934 12.9601 3 14.5556 3H17.4445C19.04 3 20.3334 4.2934 20.3334 5.88889"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 3L22.5 16L9.5 29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-device-mobile'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9999 24.6667H16.0144M10.2221 29H21.7777C23.3732 29 24.6666 27.7066 24.6666 26.1111V5.88889C24.6666 4.2934 23.3732 3 21.7777 3H10.2221C8.62665 3 7.33325 4.2934 7.33325 5.88889V26.1111C7.33325 27.7066 8.62665 29 10.2221 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-desktop-computer'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.75 23.2222L11.6667 27.5556L10.2222 29H21.7778L20.3333 27.5556L19.25 23.2222M3 17.4444H29M5.88889 23.2222H26.1111C27.7066 23.2222 29 21.9288 29 20.3333V5.88889C29 4.2934 27.7066 3 26.1111 3H5.88889C4.2934 3 3 4.2934 3 5.88889V20.3333C3 21.9288 4.2934 23.2222 5.88889 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-database'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.44434 8.77778V23.2222C4.44434 26.4132 9.61793 29 15.9999 29C22.3818 29 27.5554 26.4132 27.5554 23.2222V8.77778M4.44434 8.77778C4.44434 11.9688 9.61793 14.5556 15.9999 14.5556C22.3818 14.5556 27.5554 11.9688 27.5554 8.77778M4.44434 8.77778C4.44434 5.5868 9.61793 3 15.9999 3C22.3818 3 27.5554 5.5868 27.5554 8.77778M27.5554 16C27.5554 19.191 22.3818 21.7778 15.9999 21.7778C9.61793 21.7778 4.44434 19.191 4.44434 16"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-device-tablet'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 24.6667H16.0145M8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V5.88889C26.1111 4.2934 24.8177 3 23.2222 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V26.1111C5.88892 27.7066 7.18232 29 8.7778 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-remove'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4444H20.3334M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-pound'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 11.6667C20.3333 10.0712 19.0399 8.77778 17.4444 8.77778C15.849 8.77778 14.5556 10.0712 14.5556 11.6667V18.8889C14.5556 20.4844 13.2622 21.7778 11.6667 21.7778H20.3333M11.6667 16H17.4444M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cursor-click'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.6808 21.6807L18.7531 28.9999L12.8978 12.8977L29 18.753L21.6808 21.6807ZM21.6808 21.6807L29 28.9999M10.2457 3L11.3823 7.24187M7.24187 11.3822L3 10.2456M20.1434 5.65213L17.0381 8.7574M8.75753 17.038L5.65226 20.1432"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-search'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V12.265C26.1111 11.8819 25.959 11.5145 25.6881 11.2436L17.8675 3.42307C17.5967 3.15218 17.2293 3 16.8462 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V21.7778M5.88892 29L12.9359 21.953M12.9359 21.953C13.7201 22.7372 14.8034 23.2222 16 23.2222C18.3933 23.2222 20.3334 21.2821 20.3334 18.8889C20.3334 16.4957 18.3933 14.5556 16 14.5556C13.6068 14.5556 11.6667 16.4957 11.6667 18.8889C11.6667 20.0855 12.1517 21.1688 12.9359 21.953Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-report'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 23.2222V20.3333M16 23.2222V17.4444M20.3334 23.2222V14.5556M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-duplicate'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2221 8.77778V20.3333C10.2221 21.9288 11.5155 23.2222 13.111 23.2222H21.7777M10.2221 8.77778V5.88889C10.2221 4.2934 11.5155 3 13.111 3H19.7349C20.118 3 20.4854 3.15218 20.7563 3.42307L27.1324 9.79915C27.4033 10.07 27.5554 10.4374 27.5554 10.8205V20.3333C27.5554 21.9288 26.262 23.2222 24.6666 23.2222H21.7777M10.2221 8.77778H6.44434C5.33977 8.77778 4.44434 9.67321 4.44434 10.7778V26.1111C4.44434 27.7066 5.73774 29 7.33322 29H19.7777C20.8822 29 21.7777 28.1046 21.7777 27V23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 13.1111V21.7778M16 21.7778L11.6667 17.4444M16 21.7778L20.3334 17.4444M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-dots-horizontal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.625 16H4.64125M16 16H16.0163M27.375 16H27.3913M6.25 16C6.25 16.8975 5.52246 17.625 4.625 17.625C3.72754 17.625 3 16.8975 3 16C3 15.1025 3.72754 14.375 4.625 14.375C5.52246 14.375 6.25 15.1025 6.25 16ZM17.625 16C17.625 16.8975 16.8975 17.625 16 17.625C15.1025 17.625 14.375 16.8975 14.375 16C14.375 15.1025 15.1025 14.375 16 14.375C16.8975 14.375 17.625 15.1025 17.625 16ZM29 16C29 16.8975 28.2725 17.625 27.375 17.625C26.4775 17.625 25.75 16.8975 25.75 16C25.75 15.1025 26.4775 14.375 27.375 14.375C28.2725 14.375 29 15.1025 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-yen'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 10.2222L16 17.4444M16 17.4444L20.3333 10.2222M16 17.4444V23.2222M11.6667 16H20.3333M11.6667 20.3333H20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 22.5L3 24.125C3 26.8174 5.18261 29 7.875 29L24.125 29C26.8174 29 29 26.8174 29 24.125L29 22.5M22.5 16L16 22.5M16 22.5L9.5 16M16 22.5L16 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-dollar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.7453 12.5416C19.2285 13.0985 20.0717 13.1582 20.6285 12.675C21.1854 12.1918 21.2451 11.3486 20.7619 10.7917L18.7453 12.5416ZM13.2547 19.4584C12.7715 18.9015 11.9284 18.8418 11.3715 19.325C10.8146 19.8082 10.7549 20.6514 11.2381 21.2083L13.2547 19.4584ZM17.335 8.77778C17.335 8.04048 16.7373 7.44278 16 7.44278C15.2627 7.44278 14.665 8.04048 14.665 8.77778H17.335ZM14.665 23.2222C14.665 23.9595 15.2627 24.5572 16 24.5572C16.7373 24.5572 17.335 23.9596 17.335 23.2222L14.665 23.2222ZM27.665 16C27.665 22.4424 22.4424 27.665 16 27.665V30.335C23.917 30.335 30.335 23.917 30.335 16H27.665ZM16 27.665C9.5576 27.665 4.335 22.4424 4.335 16H1.665C1.665 23.917 8.083 30.335 16 30.335V27.665ZM4.335 16C4.335 9.5576 9.5576 4.335 16 4.335V1.665C8.083 1.665 1.665 8.083 1.665 16H4.335ZM16 4.335C22.4424 4.335 27.665 9.5576 27.665 16H30.335C30.335 8.083 23.917 1.665 16 1.665V4.335ZM16 14.665C15.0302 14.665 14.2126 14.4005 13.6764 14.0431C13.1309 13.6794 13.0017 13.3236 13.0017 13.1111H10.3317C10.3317 14.4941 11.1725 15.5827 12.1953 16.2647C13.2275 16.9528 14.5766 17.335 16 17.335V14.665ZM13.0017 13.1111C13.0017 12.8986 13.1309 12.5428 13.6764 12.1791C14.2126 11.8217 15.0302 11.5572 16 11.5572V8.88722C14.5766 8.88722 13.2275 9.26945 12.1953 9.95757C11.1725 10.6395 10.3317 11.7281 10.3317 13.1111H13.0017ZM16 11.5572C17.3281 11.5572 18.3143 12.0449 18.7453 12.5416L20.7619 10.7917C19.6944 9.56148 17.8798 8.88722 16 8.88722V11.5572ZM16 17.335C16.9698 17.335 17.7874 17.5995 18.3236 17.9569C18.8691 18.3206 18.9984 18.6764 18.9984 18.8889H21.6684C21.6684 17.5059 20.8275 16.4172 19.8047 15.7353C18.7725 15.0472 17.4234 14.665 16 14.665V17.335ZM14.665 8.77778V10.2222H17.335V8.77778H14.665ZM14.665 21.7778L14.665 23.2222L17.335 23.2222L17.335 21.7778L14.665 21.7778ZM16 20.4428C14.672 20.4428 13.6857 19.9551 13.2547 19.4584L11.2381 21.2083C12.3056 22.4385 14.1202 23.1128 16 23.1128L16 20.4428ZM18.9984 18.8889C18.9984 19.1014 18.8691 19.4572 18.3236 19.8209C17.7875 20.1783 16.9698 20.4428 16 20.4428V23.1128C17.4234 23.1128 18.7725 22.7306 19.8047 22.0424C20.8275 21.3605 21.6684 20.2719 21.6684 18.8889H18.9984ZM14.665 10.2222L14.665 21.7778L17.335 21.7778L17.335 10.2222L14.665 10.2222Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-text'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 16H20.3334M11.6667 21.7778H20.3334M23.2223 29H8.77781C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.77781 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2223 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V12.265C26.1111 11.8819 25.959 11.5145 25.6881 11.2436L17.8675 3.42307C17.5967 3.15218 17.2293 3 16.8462 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V26.1111C5.88892 27.7066 7.18232 29 8.7778 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-dots-vertical'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 27.375L16 27.3587M16 16L16 15.9837M16 4.625L16 4.60875M16 25.75C16.8975 25.75 17.625 26.4775 17.625 27.375C17.625 28.2725 16.8975 29 16 29C15.1025 29 14.375 28.2725 14.375 27.375C14.375 26.4775 15.1025 25.75 16 25.75ZM16 14.375C16.8975 14.375 17.625 15.1025 17.625 16C17.625 16.8975 16.8975 17.625 16 17.625C15.1025 17.625 14.375 16.8975 14.375 16C14.375 15.1025 15.1025 14.375 16 14.375ZM16 3C16.8975 3 17.625 3.72754 17.625 4.625C17.625 5.52246 16.8975 6.25 16 6.25C15.1025 6.25 14.375 5.52246 14.375 4.625C14.375 3.72754 15.1025 3 16 3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-emoji-sad'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0854 22.0257C17.8291 19.7693 14.1708 19.7693 11.9144 22.0257M20.3333 13.1111H20.3189M11.6667 13.1111H11.6522M3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-dots-circle-horizontal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 16H10.2367M16 16H16.0144M21.7778 16H21.7922M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-exclamation-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10.2222V16M16 21.7778H16.0144M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-exclamation'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 13.0889V16.0001M16 21.8224H16.0146M5.91549 27.6446H26.0845C28.3255 27.6446 29.7261 25.2187 28.6056 23.2779L18.5211 5.81104C17.4006 3.87028 14.5994 3.87028 13.4789 5.81104L3.39436 23.2779C2.27386 25.2187 3.67449 27.6446 5.91549 27.6446Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-fire'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24.1709 25.6155C19.6582 30.1282 12.3416 30.1282 7.82888 25.6155C5.57252 23.3591 4.44434 20.4018 4.44434 17.4445C4.44433 14.4871 5.57251 11.5298 7.82888 9.27342C7.82888 9.27342 8.77774 11.6666 11.6666 13.1111C11.6666 10.2222 12.3888 5.88883 15.9795 3C18.8888 5.88889 21.9094 7.01187 24.1709 9.27342C26.4273 11.5298 27.5555 14.4871 27.5555 17.4445C27.5555 20.4018 26.4273 23.3591 24.1709 25.6155Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.9358 21.953C14.628 23.6452 17.3718 23.6452 19.064 21.953C19.9102 21.1068 20.3332 19.9979 20.3332 18.8889C20.3332 17.7799 19.9102 16.6709 19.064 15.8247C18.2232 14.9839 17.1229 14.5609 16.0209 14.5555L14.5554 18.8888L11.6666 18.8889C11.6666 19.9979 12.0896 21.1068 12.9358 21.953Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-finger-print'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.7282 14.6568C16.7282 19.7818 15.2583 24.5634 12.7171 28.6031M7.70442 25.6293C7.73022 25.5859 7.75665 25.5427 7.78372 25.4996C9.75735 22.3622 10.8999 18.6519 10.8999 14.6568C10.8999 11.4379 13.5094 8.82841 16.7283 8.82841C19.9472 8.82841 22.5567 11.4379 22.5567 14.6568C22.5567 16.1388 22.4558 17.5981 22.2605 19.0281M19.1752 29C20.0665 27.2209 20.7973 25.3474 21.3485 23.3994M26.9422 25.0488C27.8821 21.7466 28.3853 18.2605 28.3853 14.6568C28.3853 8.21894 23.1663 3 16.7284 3C14.6052 3 12.6146 3.56765 10.9 4.55948M3.6145 21.0158C4.54801 19.0942 5.07161 16.9367 5.07161 14.6568C5.07161 12.5336 5.63926 10.543 6.63108 8.82841"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-eye-off'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.73806 3.73865L8.62782 8.62841M28.2607 28.2613L23.3714 23.372M18.5537 25.2976C17.7265 25.4545 16.8728 25.5366 16 25.5366C9.89979 25.5366 4.736 21.5272 3 15.9999C3.4726 14.4952 4.19923 13.103 5.12963 11.8736M13.1094 13.11C13.849 12.3703 14.8708 11.9129 15.9994 11.9129C18.2566 11.9129 20.0865 13.7427 20.0865 16C20.0865 17.1286 19.629 18.1504 18.8894 18.89M13.1094 13.11L18.8894 18.89M13.1094 13.11L8.62782 8.62841M18.8894 18.89L8.62782 8.62841M18.8894 18.89L23.3714 23.372M8.62782 8.62841C10.7529 7.25839 13.2836 6.46339 16 6.46339C22.1002 6.46339 27.264 10.4727 29 16C28.0369 19.0663 26.019 21.6654 23.3714 23.372"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-external-link'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.75 6.25H6.25C4.45507 6.25 3 7.70507 3 9.5V25.75C3 27.5449 4.45507 29 6.25 29H22.5C24.2949 29 25.75 27.5449 25.75 25.75V19.25M19.25 3H29M29 3V12.75M29 3L12.75 19.25"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-duplicate'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 22.5H6.25C4.45507 22.5 3 21.0449 3 19.25V6.25C3 4.45507 4.45507 3 6.25 3H19.25C21.0449 3 22.5 4.45507 22.5 6.25V9.5M12.75 29H25.75C27.5449 29 29 27.5449 29 25.75V12.75C29 10.9551 27.5449 9.5 25.75 9.5H12.75C10.9551 9.5 9.5 10.9551 9.5 12.75V25.75C9.5 27.5449 10.9551 29 12.75 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-flag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 29V23.2222M3 23.2222V5.88889C3 4.2934 4.2934 3 5.88889 3H15.2778L16.7222 4.44444H29L24.6667 13.1111L29 21.7778H16.7222L15.2778 20.3333H5.88889C4.2934 20.3333 3 21.6267 3 23.2222ZM16 3.72222V11.6667"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4445H20.3333M16 13.1111V21.7778M3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H14.5556L17.4444 8.7778H26.1111C27.7066 8.7778 29 10.0712 29 11.6667V23.2222C29 24.8177 27.7066 26.1111 26.1111 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-remove'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4445H20.3333M3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H14.5556L17.4444 8.7778H26.1111C27.7066 8.7778 29 10.0712 29 11.6667V23.2222C29 24.8177 27.7066 26.1111 26.1111 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-film'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 4.44446V27.5556M23.2222 4.44446V27.5556M3 10.2222H8.77778M23.2222 10.2222H29M3 16H29M3 21.7778H8.77778M23.2222 21.7778H29M4.44444 27.5556H27.5556C28.3533 27.5556 29 26.9089 29 26.1111V5.8889C29 5.09116 28.3533 4.44446 27.5556 4.44446H4.44444C3.6467 4.44446 3 5.09116 3 5.8889V26.1111C3 26.9089 3.6467 27.5556 4.44444 27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 26.1111C4.2934 26.1111 3 24.8177 3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H11.6667L14.5556 8.7778H20.3333C21.9288 8.7778 23.2222 10.0712 23.2222 11.6667V13.1111M5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V16C29 14.4045 27.7066 13.1111 26.1111 13.1111H11.6667C10.0712 13.1111 8.77778 14.4045 8.77778 16V23.2222C8.77778 24.8177 7.48438 26.1111 5.88889 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 8.7778V23.2222C3 24.8177 4.2934 26.1111 5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V11.6667C29 10.0712 27.7066 8.7778 26.1111 8.7778H17.4444L14.5556 5.88892H5.88889C4.2934 5.88892 3 7.18232 3 8.7778Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4444H20.3334M16 13.1111L16 21.7778M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-hashtag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.875 29L14.375 3M17.625 29L24.125 3M6.25 11.125H29M3 20.875H25.75"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-filter'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4C3 3.44772 3.44772 3 4 3H28C28.5523 3 29 3.44772 29 4V8.36356C29 8.62878 28.8946 8.88313 28.7071 9.07067L19.1818 18.596C18.9942 18.7835 18.8889 19.0379 18.8889 19.3031V23.2222L13.1111 29V19.3031C13.1111 19.0379 13.0058 18.7835 12.8182 18.596L3.29289 9.07067C3.10536 8.88313 3 8.62878 3 8.36356V4Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-eye'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0865 16C20.0865 18.2572 18.2566 20.0871 15.9994 20.0871C13.7421 20.0871 11.9123 18.2572 11.9123 16C11.9123 13.7427 13.7421 11.9129 15.9994 11.9129C18.2566 11.9129 20.0865 13.7427 20.0865 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3 15.9999C4.73603 10.4727 9.8998 6.46338 16 6.46338C22.1002 6.46338 27.264 10.4727 29 16C27.264 21.5273 22.1002 25.5366 16 25.5366C9.89979 25.5366 4.736 21.5272 3 15.9999Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-gift'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10.2222V29M16 10.2222C16 10.2222 16 8.06599 16 7.33333C16 5.73784 17.2934 4.44444 18.8889 4.44444C20.4844 4.44444 21.7778 5.73784 21.7778 7.33333C21.7778 8.92882 20.4844 10.2222 18.8889 10.2222C18.0261 10.2222 16 10.2222 16 10.2222ZM16 10.2222C16 10.2222 16 7.42421 16 6.61111C16 4.61675 14.3833 3 12.3889 3C10.3945 3 8.77778 4.61675 8.77778 6.61111C8.77778 8.60547 10.3945 10.2222 12.3889 10.2222C13.5702 10.2222 16 10.2222 16 10.2222ZM5.88889 16H26.1111M5.88889 16C4.2934 16 3 14.7066 3 13.1111C3 11.5156 4.2934 10.2222 5.88889 10.2222H26.1111C27.7066 10.2222 29 11.5156 29 13.1111C29 14.7066 27.7066 16 26.1111 16M5.88889 16L5.88889 26.1111C5.88889 27.7066 7.18229 29 8.77778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-heart'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.90381 6.80761C2.3654 9.34602 2.3654 13.4616 4.90381 16L16.0001 27.0963L27.0962 16C29.6346 13.4616 29.6346 9.34602 27.0962 6.80761C24.5578 4.26921 20.4422 4.26921 17.9038 6.80762L16.0001 8.7115L14.0962 6.80761C11.5578 4.26921 7.44221 4.26921 4.90381 6.80761Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-fast-forward'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.7565 17.3565C15.6609 16.6783 15.6609 15.3218 14.7565 14.6435L5.71304 7.86089C4.59521 7.02251 3 7.82011 3 9.21741L3 22.7826C3 24.1799 4.59521 24.9775 5.71304 24.1391L14.7565 17.3565Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.3217 17.3565C29.2261 16.6783 29.2261 15.3218 28.3217 14.6435L19.2783 7.86089C18.1604 7.02251 16.5652 7.82011 16.5652 9.21741L16.5652 22.7826C16.5652 24.1799 18.1604 24.9775 19.2783 24.1391L28.3217 17.3565Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-icon-user-remove'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 16H20.3333M17.4444 8.77778C17.4444 11.9688 14.8576 14.5556 11.6667 14.5556C8.47569 14.5556 5.88889 11.9688 5.88889 8.77778C5.88889 5.5868 8.47569 3 11.6667 3C14.8576 3 17.4444 5.5868 17.4444 8.77778ZM3 27.5556C3 22.7691 6.8802 18.8889 11.6667 18.8889C16.4531 18.8889 20.3333 22.7691 20.3333 27.5556V29H3V27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 13.1111V21.7778M16 21.7778L11.6667 17.4445M16 21.7778L20.3333 17.4445M3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H14.5556L17.4444 8.7778H26.1111C27.7066 8.7778 29 10.0712 29 11.6667V23.2222C29 24.8177 27.7066 26.1111 26.1111 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-home'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 16L5.88889 13.1111M5.88889 13.1111L16 3L26.1111 13.1111M5.88889 13.1111V27.5556C5.88889 28.3533 6.53559 29 7.33333 29H11.6667M26.1111 13.1111L29 16M26.1111 13.1111V27.5556C26.1111 28.3533 25.4644 29 24.6667 29H20.3333M11.6667 29C12.4644 29 13.1111 28.3533 13.1111 27.5556V21.7778C13.1111 20.98 13.7578 20.3333 14.5556 20.3333H17.4444C18.2422 20.3333 18.8889 20.98 18.8889 21.7778V27.5556C18.8889 28.3533 19.5356 29 20.3333 29M11.6667 29H20.3333"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-identification'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 8.77779H5.88889C4.2934 8.77779 3 10.0712 3 11.6667V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V11.6667C29 10.0712 27.7066 8.77779 26.1111 8.77779H18.8889M13.1111 8.77779V7.33335C13.1111 5.73786 14.4045 4.44446 16 4.44446C17.5955 4.44446 18.8889 5.73786 18.8889 7.33335V8.77779M13.1111 8.77779C13.1111 10.3733 14.4045 11.6667 16 11.6667C17.5955 11.6667 18.8889 10.3733 18.8889 8.77779M11.6667 20.3333C13.2622 20.3333 14.5556 19.0399 14.5556 17.4445C14.5556 15.849 13.2622 14.5556 11.6667 14.5556C10.0712 14.5556 8.77778 15.849 8.77778 17.4445C8.77778 19.0399 10.0712 20.3333 11.6667 20.3333ZM11.6667 20.3333C13.5534 20.3333 15.1585 21.5392 15.7534 23.2222M11.6667 20.3333C9.77991 20.3333 8.17471 21.5392 7.57983 23.2222M20.3333 16H24.6667M20.3333 21.7778H23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-hand'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.50008 15.2778V18.8889M9.50008 15.2778V6.61111C9.50008 5.41449 10.4701 4.44444 11.6667 4.44444C12.8634 4.44444 13.8334 5.41449 13.8334 6.61111M9.50008 15.2778C9.50008 14.0812 8.53003 13.1111 7.33341 13.1111C6.1368 13.1111 5.16675 14.0812 5.16675 15.2778V18.1667C5.16675 24.1498 10.017 29 16.0001 29C21.9832 29 26.8334 24.1498 26.8334 18.1667V10.9444C26.8334 9.74783 25.8634 8.77778 24.6667 8.77778C23.4701 8.77778 22.5001 9.74783 22.5001 10.9444M13.8334 6.61111V14.5556M13.8334 6.61111V5.16667C13.8334 3.97005 14.8035 3 16.0001 3C17.1967 3 18.1667 3.97005 18.1667 5.16667V6.61111M18.1667 6.61111V14.5556M18.1667 6.61111C18.1667 5.41449 19.1368 4.44444 20.3334 4.44444C21.53 4.44444 22.5001 5.41449 22.5001 6.61111V10.9444M22.5001 10.9444V14.5556"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-inbox-in'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.8823 4.52941H6.82347C5.13413 4.52941 3.76465 5.89889 3.76465 7.58824V25.9412C3.76465 27.6305 5.13413 29 6.82347 29H25.1764C26.8658 29 28.2352 27.6305 28.2352 25.9412V7.58824C28.2352 5.89889 26.8658 4.52941 25.1764 4.52941H22.1176M15.9999 3V15.2353M15.9999 15.2353L20.5882 10.6471M15.9999 15.2353L11.4117 10.6471M3.76465 18.2941H7.71938C8.12501 18.2941 8.51402 18.4553 8.80084 18.7421L12.4932 22.4344C12.78 22.7212 13.169 22.8824 13.5746 22.8824H18.4253C18.8309 22.8824 19.2199 22.7212 19.5067 22.4344L23.199 18.7421C23.4859 18.4553 23.8749 18.2941 24.2805 18.2941H28.2352"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-information-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 21.7778H16V16H14.5556M16 10.2222H16.0144M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-inbox'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 17.625V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V17.625M29 17.625V25.75C29 27.5449 27.5449 29 25.75 29H6.25C4.45507 29 3 27.5449 3 25.75V17.625M29 17.625H24.7981C24.3671 17.625 23.9538 17.7962 23.649 18.101L19.726 22.024C19.4212 22.3288 19.0079 22.5 18.5769 22.5H13.4231C12.9921 22.5 12.5788 22.3288 12.274 22.024L8.35095 18.101C8.04621 17.7962 7.63288 17.625 7.2019 17.625H3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-globe'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.07934 14.5556H5.88889C7.48438 14.5556 8.77778 15.849 8.77778 17.4444V18.8889C8.77778 20.4844 10.0712 21.7778 11.6667 21.7778C13.2622 21.7778 14.5556 23.0712 14.5556 24.6667V28.9207M10.2222 4.35131V6.61111C10.2222 8.60547 11.839 10.2222 13.8333 10.2222H14.5556C16.151 10.2222 17.4444 11.5156 17.4444 13.1111C17.4444 14.7066 18.7378 16 20.3333 16C21.9288 16 23.2222 14.7066 23.2222 13.1111C23.2222 11.5156 24.5156 10.2222 26.1111 10.2222L27.6487 10.2222M20.3333 28.2603V24.6667C20.3333 23.0712 21.6267 21.7778 23.2222 21.7778H27.6487M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-globe-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 16C29 23.1797 23.1797 29 16 29M29 16C29 8.8203 23.1797 3 16 3M29 16H3M16 29C8.8203 29 3 23.1797 3 16M16 29C18.3932 29 20.3333 23.1797 20.3333 16C20.3333 8.8203 18.3932 3 16 3M16 29C13.6068 29 11.6667 23.1797 11.6667 16C11.6667 8.8203 13.6068 3 16 3M3 16C3 8.8203 8.8203 3 16 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-light-bulb'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.625 23.2222H19.3748M15.9999 3V4.44444M25.1923 6.80761L24.1709 7.82899M29 15.9999H27.5556M4.44444 15.9999H3M7.82891 7.82899L6.80753 6.80761M10.893 21.1069C8.07259 18.2865 8.07259 13.7136 10.893 10.8932C13.7135 8.0727 18.2864 8.0727 21.1068 10.8932C23.9273 13.7136 23.9273 18.2865 21.1068 21.1069L20.3166 21.8972C19.4024 22.8113 18.8888 24.0512 18.8888 25.344V26.1111C18.8888 27.7066 17.5954 29 15.9999 29C14.4044 29 13.111 27.7066 13.111 26.1111V25.344C13.111 24.0512 12.5975 22.8113 11.6833 21.8972L10.893 21.1069Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-lightning-bolt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4443 13.1111V3L4.44434 18.8889H14.5554L14.5554 29L27.5554 13.1111L17.4443 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-lock-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2221 14.5556V8.77778C10.2221 5.5868 12.8089 3 15.9999 3C19.1909 3 21.7777 5.5868 21.7777 8.77778M15.9999 20.3333V23.2222M7.33322 29H24.6666C26.262 29 27.5554 27.7066 27.5554 26.1111V17.4444C27.5554 15.849 26.262 14.5556 24.6666 14.5556H7.33322C5.73774 14.5556 4.44434 15.849 4.44434 17.4444V26.1111C4.44434 27.7066 5.73774 29 7.33322 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-lock-closed'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9999 20.3333V23.2222M7.33322 29H24.6666C26.262 29 27.5554 27.7066 27.5554 26.1111V17.4444C27.5554 15.849 26.262 14.5556 24.6666 14.5556H7.33322C5.73774 14.5556 4.44434 15.849 4.44434 17.4444V26.1111C4.44434 27.7066 5.73774 29 7.33322 29ZM21.7777 14.5556V8.77778C21.7777 5.5868 19.1909 3 15.9999 3C12.8089 3 10.2221 5.5868 10.2221 8.77778V14.5556H21.7777Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-location-marker'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.6152 21.3848C22.2353 22.7648 19.2071 25.7929 17.4129 27.5871C16.6319 28.3682 15.3686 28.3686 14.5875 27.5875C12.8234 25.8233 9.85815 22.8581 8.3848 21.3848C4.17903 17.179 4.17903 10.3601 8.3848 6.15433C12.5906 1.94856 19.4095 1.94856 23.6152 6.15433C27.821 10.3601 27.821 17.179 23.6152 21.3848Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.0386 13.7696C20.0386 16 18.2305 17.8081 16 17.8081C13.7696 17.8081 11.9614 16 11.9614 13.7696C11.9614 11.5391 13.7696 9.73097 16 9.73097C18.2305 9.73097 20.0386 11.5391 20.0386 13.7696Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-logout-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 21.7778L8.77778 16M8.77778 16L14.5556 10.2222M8.77778 16L29 16M21.7778 21.7778V23.2222C21.7778 25.6155 19.8377 27.5556 17.4444 27.5556H7.33333C4.9401 27.5556 3 25.6155 3 23.2222V8.77779C3 6.38456 4.9401 4.44446 7.33333 4.44446H17.4444C19.8377 4.44446 21.7778 6.38456 21.7778 8.77779V10.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-library'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 18.8889V23.2222M16 18.8889V23.2222M21.7778 18.8889V23.2222M3 29H29M3 13.1111H29M3 8.77778L16 3L29 8.77778M4.44444 13.1111H27.5556V29H4.44444V13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-key'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 8.77778C21.9288 8.77778 23.2222 10.0712 23.2222 11.6667M29 11.6667C29 16.4531 25.1198 20.3333 20.3333 20.3333C19.4578 20.3333 18.6125 20.2035 17.8158 19.962L14.5556 23.2222H11.6667V26.1111H8.77778V29H4.44444C3.6467 29 3 28.3533 3 27.5556V23.8205C3 23.4374 3.15218 23.07 3.42307 22.7992L12.038 14.1842C11.7965 13.3875 11.6667 12.5422 11.6667 11.6667C11.6667 6.8802 15.5469 3 20.3333 3C25.1198 3 29 6.8802 29 11.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-mail'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 10.2222L14.3975 17.8206C15.3679 18.4675 16.6321 18.4675 17.6025 17.8206L29 10.2222M5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H5.88889C4.2934 5.88892 3 7.18232 3 8.7778V23.2222C3 24.8177 4.2934 26.1111 5.88889 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.25H29M3 16H29M3 25.75H29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu-alt-2'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.25H29M3 16H29M3 25.75H14.375" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-mail-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 25.8195V12.9211C3 11.9552 3.48274 11.0532 4.28642 10.5174L14.3975 3.77669C15.3679 3.12977 16.6321 3.12977 17.6025 3.77669L27.7136 10.5174C28.5173 11.0532 29 11.9552 29 12.9211V25.8195M3 25.8195C3 27.415 4.2934 28.7084 5.88889 28.7084H26.1111C27.7066 28.7084 29 27.415 29 25.8195M3 25.8195L12.75 19.3195M29 25.8195L19.25 19.3195M3 12.8195L12.75 19.3195M29 12.8195L19.25 19.3195M19.25 19.3195L17.6025 20.4178C16.6321 21.0648 15.3679 21.0648 14.3975 20.4178L12.75 19.3195"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-emoji-happy'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9145 20.0855C14.1709 22.3419 17.8291 22.3419 20.0855 20.0855M20.3333 13.1111H20.3189M11.6667 13.1111H11.6522M3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-minus-sm'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 16H3" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu-alt-3'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.25H29M3 16H29M17.625 25.75H29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-moon'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 20.5415C27.447 21.1656 25.751 21.509 23.9748 21.509C16.5279 21.509 10.491 15.4721 10.491 8.02524C10.491 6.24901 10.8344 4.55301 11.4585 3C6.50051 4.99249 3 9.84556 3 15.5162C3 22.9631 9.03689 29 16.4838 29C22.1544 29 27.0075 25.4995 29 20.5415Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-map'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 27.5556L3.79847 23.6215C3.30911 23.3768 3 22.8766 3 22.3295V6.78162C3 5.70784 4.13001 5.00946 5.09042 5.48967L11.6667 8.77779M11.6667 27.5556L20.3333 23.2222M11.6667 27.5556V8.77779M20.3333 23.2222L26.9096 26.5104C27.87 26.9906 29 26.2922 29 25.2184V9.67051C29 9.12339 28.6909 8.62323 28.2015 8.37856L20.3333 4.44446M20.3333 23.2222V4.44446M20.3333 4.44446L11.6667 8.77779"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-microphone'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M25.0999 14.7C25.0999 19.7258 21.0257 23.8 15.9999 23.8M15.9999 23.8C10.9741 23.8 6.8999 19.7258 6.8999 14.7M15.9999 23.8V29M15.9999 29H10.7999M15.9999 29H21.1999M15.9999 18.6C13.846 18.6 12.0999 16.8539 12.0999 14.7V6.9C12.0999 4.74609 13.846 3 15.9999 3C18.1538 3 19.8999 4.74609 19.8999 6.9V14.7C19.8999 16.8539 18.1538 18.6 15.9999 18.6Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-music-note'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 26.1111V7.33333L29 3V21.7778M11.6667 26.1111C11.6667 27.7066 9.72657 29 7.33333 29C4.9401 29 3 27.7066 3 26.1111C3 24.5156 4.9401 23.2222 7.33333 23.2222C9.72657 23.2222 11.6667 24.5156 11.6667 26.1111ZM29 21.7778C29 23.3733 27.0599 24.6667 24.6667 24.6667C22.2734 24.6667 20.3333 23.3733 20.3333 21.7778C20.3333 20.1823 22.2734 18.8889 24.6667 18.8889C27.0599 18.8889 29 20.1823 29 21.7778ZM11.6667 13.1111L29 8.77778"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-paper-airplane'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 26.1111L29 29L16 3L3 29L16 26.1111ZM16 26.1111V14.5556"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-newspaper'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 27.5556H5.88889C4.2934 27.5556 3 26.2622 3 24.6667L3 7.33335C3 5.73786 4.2934 4.44446 5.88889 4.44446L20.3333 4.44446C21.9288 4.44446 23.2222 5.73786 23.2222 7.33335V8.77779M26.1111 27.5556C24.5156 27.5556 23.2222 26.2622 23.2222 24.6667L23.2222 8.77779M26.1111 27.5556C27.7066 27.5556 29 26.2622 29 24.6667V11.6667C29 10.0712 27.7066 8.77779 26.1111 8.77779L23.2222 8.77779M17.4444 4.44446L11.6667 4.44446M8.77778 21.7778H17.4444M8.77778 10.2222H17.4444V16H8.77778V10.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-paper-clip'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.22 8.77778L10.7072 18.2906C9.57898 19.4188 9.57899 21.2479 10.7072 22.3761C11.8353 23.5043 13.6645 23.5043 14.7927 22.3761L24.0576 12.8633C26.314 10.6069 26.314 6.94863 24.0576 4.69227C21.8013 2.43591 18.143 2.43591 15.8866 4.69227L6.62166 14.2051C3.23712 17.5896 3.23712 23.077 6.62166 26.4616C10.0062 29.8461 15.4936 29.8461 18.8782 26.4616L27.9166 17.4444"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-logout-rught'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 21.7778L29 16M29 16L23.2222 10.2222M29 16L8.77778 16M17.4444 21.7778V23.2222C17.4444 25.6155 15.5043 27.5556 13.1111 27.5556H7.33333C4.9401 27.5556 3 25.6155 3 23.2222V8.77779C3 6.38456 4.9401 4.44446 7.33333 4.44446H13.1111C15.5043 4.44446 17.4444 6.38456 17.4444 8.77779V10.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-pause'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 11.6667V20.3333M18.8889 11.6667V20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone-missed-call'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 10.2222L24.6666 7.33333M24.6666 7.33333L27.5555 4.44444M24.6666 7.33333L21.7777 4.44444M24.6666 7.33333L27.5555 10.2222M5.88889 3C4.2934 3 3 4.2934 3 5.88889V7.33333C3 19.2995 12.7005 29 24.6667 29H26.1111C27.7066 29 29 27.7066 29 26.1111V21.3744C29 20.7527 28.6022 20.2007 28.0123 20.0041L21.5218 17.8406C20.8399 17.6133 20.0946 17.922 19.7731 18.5649L18.1428 21.8254C14.6116 20.2333 11.7667 17.3884 10.1746 13.8572L13.4351 12.2269C14.078 11.9054 14.3867 11.1601 14.1594 10.4782L11.9959 3.98767C11.7993 3.39784 11.2473 3 10.6256 3H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-minus-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 16H11.6667M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone-outgoing'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7778 3H29M29 3V10.2222M29 3L20.3333 11.6667M5.88889 3C4.2934 3 3 4.2934 3 5.88889V7.33333C3 19.2995 12.7005 29 24.6667 29H26.1111C27.7066 29 29 27.7066 29 26.1111V21.3744C29 20.7527 28.6022 20.2007 28.0123 20.0041L21.5218 17.8406C20.8399 17.6133 20.0946 17.922 19.7731 18.5649L18.1428 21.8254C14.6116 20.2333 11.7667 17.3884 10.1746 13.8572L13.4351 12.2269C14.078 11.9054 14.3867 11.1601 14.1594 10.4782L11.9959 3.98767C11.7993 3.39784 11.2473 3 10.6256 3H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-photograph'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 22.5L10.4519 15.0481C11.7211 13.7789 13.7789 13.7789 15.0481 15.0481L22.5 22.5M19.25 19.25L21.8269 16.6731C23.0961 15.4039 25.1539 15.4039 26.4231 16.6731L29 19.25M19.25 9.5H19.2663M6.25 29H25.75C27.5449 29 29 27.5449 29 25.75V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-pencil'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.6596 6.21799L25.7564 11.3148M22.822 4.05559C24.2294 2.64814 26.5114 2.64814 27.9188 4.05559C29.3263 5.46304 29.3263 7.74497 27.9188 9.15243L8.07125 29H3.02563V23.8519L22.822 4.05559Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone-incoming'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 3L20.3333 11.6667M20.3333 11.6667V4.44444M20.3333 11.6667H27.5556M5.88889 3C4.2934 3 3 4.2934 3 5.88889V7.33333C3 19.2995 12.7005 29 24.6667 29H26.1111C27.7066 29 29 27.7066 29 26.1111V21.3744C29 20.7527 28.6022 20.2007 28.0123 20.0041L21.5218 17.8406C20.8399 17.6133 20.0946 17.922 19.7731 18.5649L18.1428 21.8254C14.6116 20.2333 11.7667 17.3884 10.1746 13.8572L13.4351 12.2269C14.078 11.9054 14.3867 11.1601 14.1594 10.4782L11.9959 3.98767C11.7993 3.39784 11.2473 3 10.6256 3H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-play'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.975 14.7981L15.3568 11.7193C14.3969 11.0794 13.1111 11.7675 13.1111 12.9212V19.0788C13.1111 20.2325 14.3969 20.9206 15.3568 20.2807L19.975 17.2019C20.8326 16.6301 20.8326 15.3699 19.975 14.7981Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-presentation-chart-line'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.44444 3.72217V2.38717H3.10944V3.72217H4.44444ZM27.5556 3.72217H28.8906V2.38717H27.5556V3.72217ZM7.83379 14.3337C7.31244 14.8551 7.31244 15.7004 7.83379 16.2217C8.35514 16.7431 9.20042 16.7431 9.72177 16.2217L7.83379 14.3337ZM13.1111 10.9444L14.0551 10.0004C13.5337 9.47905 12.6885 9.47905 12.1671 10.0004L13.1111 10.9444ZM17.4444 15.2777L16.5005 16.2217C17.0218 16.7431 17.8671 16.7431 18.3884 16.2217L17.4444 15.2777ZM24.1662 10.4439C24.6876 9.92258 24.6876 9.07731 24.1662 8.55596C23.6449 8.03461 22.7996 8.03461 22.2782 8.55596L24.1662 10.4439ZM9.27823 27.3337C8.75688 27.8551 8.75688 28.7004 9.27823 29.2217C9.79958 29.7431 10.6449 29.7431 11.1662 29.2217L9.27823 27.3337ZM16 22.4999L16.944 21.556C16.4226 21.0346 15.5774 21.0346 15.056 21.556L16 22.4999ZM20.8338 29.2217C21.3551 29.7431 22.2004 29.7431 22.7218 29.2217C23.2431 28.7004 23.2431 27.8551 22.7218 27.3337L20.8338 29.2217ZM3 2.38717C2.2627 2.38717 1.665 2.98487 1.665 3.72217C1.665 4.45947 2.2627 5.05717 3 5.05717V2.38717ZM29 5.05717C29.7373 5.05717 30.335 4.45947 30.335 3.72217C30.335 2.98487 29.7373 2.38717 29 2.38717V5.05717ZM4.44444 5.05717H27.5556V2.38717H4.44444V5.05717ZM26.2206 3.72217V21.0555H28.8906V3.72217H26.2206ZM26.1111 21.1649H5.88889V23.8349H26.1111V21.1649ZM5.77944 21.0555V3.72217H3.10944V21.0555H5.77944ZM5.88889 21.1649C5.82844 21.1649 5.77944 21.1159 5.77944 21.0555H3.10944C3.10944 22.5905 4.35384 23.8349 5.88889 23.8349V21.1649ZM26.2206 21.0555C26.2206 21.1159 26.1716 21.1649 26.1111 21.1649V23.8349C27.6462 23.8349 28.8906 22.5905 28.8906 21.0555H26.2206ZM9.72177 16.2217L14.0551 11.8884L12.1671 10.0004L7.83379 14.3337L9.72177 16.2217ZM12.1671 11.8884L16.5005 16.2217L18.3884 14.3337L14.0551 10.0004L12.1671 11.8884ZM18.3884 16.2217L24.1662 10.4439L22.2782 8.55596L16.5005 14.3337L18.3884 16.2217ZM11.1662 29.2217L16.944 23.4439L15.056 21.556L9.27823 27.3337L11.1662 29.2217ZM15.056 23.4439L20.8338 29.2217L22.7218 27.3337L16.944 21.556L15.056 23.4439ZM3 5.05717H29V2.38717H3V5.05717Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-link'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.6411 13.3589C16.3847 11.1026 12.7264 11.1026 10.47 13.3589L4.69227 19.1367C2.43591 21.3931 2.43591 25.0514 4.69227 27.3077C6.94863 29.5641 10.6069 29.5641 12.8633 27.3077L14.4544 25.7166M13.3589 18.6411C15.6153 20.8974 19.2736 20.8974 21.5299 18.6411L27.3077 12.8633C29.5641 10.6069 29.5641 6.94863 27.3077 4.69227C25.0514 2.43591 21.3931 2.43591 19.1367 4.69227L17.5484 6.2806"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-plus-sm'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 3V16M16 16V29M16 16H29M16 16L3 16" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-office-building'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 29V5.88889C26.1111 4.2934 24.8177 3 23.2222 3H8.77778C7.18229 3 5.88889 4.2934 5.88889 5.88889V29M26.1111 29L29 29M26.1111 29H18.8889M5.88889 29L3 29M5.88889 29H13.1111M11.6667 8.77774H13.1111M11.6667 14.5555H13.1111M18.8889 8.77774H20.3333M18.8889 14.5555H20.3333M13.1111 29V21.7777C13.1111 20.98 13.7578 20.3333 14.5556 20.3333H17.4444C18.2422 20.3333 18.8889 20.98 18.8889 21.7777V29M13.1111 29H18.8889"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-puzzle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5.88889C16 4.2934 17.2934 3 18.8889 3C20.4844 3 21.7778 4.2934 21.7778 5.88889V7.33333C21.7778 8.13108 22.4245 8.77778 23.2222 8.77778H27.5556C28.3533 8.77778 29 9.42448 29 10.2222V14.5556C29 15.3533 28.3533 16 27.5556 16H26.1111C24.5156 16 23.2222 17.2934 23.2222 18.8889C23.2222 20.4844 24.5156 21.7778 26.1111 21.7778H27.5556C28.3533 21.7778 29 22.4245 29 23.2222V27.5556C29 28.3533 28.3533 29 27.5556 29H23.2222C22.4245 29 21.7778 28.3533 21.7778 27.5556V26.1111C21.7778 24.5156 20.4844 23.2222 18.8889 23.2222C17.2934 23.2222 16 24.5156 16 26.1111V27.5556C16 28.3533 15.3533 29 14.5556 29H10.2222C9.42448 29 8.77778 28.3533 8.77778 27.5556V23.2222C8.77778 22.4245 8.13108 21.7778 7.33333 21.7778H5.88889C4.2934 21.7778 3 20.4844 3 18.8889C3 17.2934 4.2934 16 5.88889 16H7.33333C8.13108 16 8.77778 15.3533 8.77778 14.5556V10.2222C8.77778 9.42448 9.42448 8.77778 10.2222 8.77778H14.5556C15.3533 8.77778 16 8.13108 16 7.33333V5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu-alt-4'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 9.5H29M3 22.5H29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-plus'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 3V29M29 16L3 16" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-receipt-refund'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 20.3333V18.8889C21.7777 15.6979 19.1909 13.1111 15.9999 13.1111H10.2221M10.2221 13.1111L14.5554 17.4444M10.2221 13.1111L14.5554 8.77778M27.5554 29V5.88889C27.5554 4.2934 26.262 3 24.6666 3H7.33322C5.73774 3 4.44434 4.2934 4.44434 5.88889V29L10.2221 26.1111L15.9999 29L21.7777 26.1111L27.5554 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-refresh'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 3V11.125H3.94497M28.8994 14.375C28.0998 7.96224 22.6294 3 16 3C10.5443 3 5.87347 6.36078 3.94497 11.125M3.94497 11.125H11.125M29 29V20.875H28.055M28.055 20.875C26.1265 25.6392 21.4557 29 16 29C9.37062 29 3.90024 24.0378 3.10058 17.625M28.055 20.875H20.875"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-receipt-tax'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 18.8889L20.3334 10.2222M12.389 10.9444H12.4034M19.6112 18.1667H19.6256M26.1111 29V5.88889C26.1111 4.2934 24.8177 3 23.2222 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V29L10.9445 26.1111L16 29L21.0556 26.1111L26.1111 29ZM13.1111 10.9444C13.1111 11.3433 12.7878 11.6667 12.3889 11.6667C11.99 11.6667 11.6667 11.3433 11.6667 10.9444C11.6667 10.5456 11.99 10.2222 12.3889 10.2222C12.7878 10.2222 13.1111 10.5456 13.1111 10.9444ZM20.3334 18.1667C20.3334 18.5655 20.01 18.8889 19.6111 18.8889C19.2123 18.8889 18.8889 18.5655 18.8889 18.1667C18.8889 17.7678 19.2123 17.4444 19.6111 17.4444C20.01 17.4444 20.3334 17.7678 20.3334 18.1667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-qrcode'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.3269 3.00818C17.3269 2.27088 16.7292 1.67318 15.9919 1.67318C15.2546 1.67318 14.6569 2.27088 14.6569 3.00818H17.3269ZM14.6569 4.63216C14.6569 5.36946 15.2546 5.96716 15.9919 5.96716C16.7292 5.96716 17.3269 5.36946 17.3269 4.63216H14.6569ZM25.7358 21.161C24.9985 21.161 24.4008 21.7587 24.4008 22.496C24.4008 23.2333 24.9985 23.831 25.7358 23.831V21.161ZM28.9838 23.831C29.7211 23.831 30.3188 23.2333 30.3188 22.496C30.3188 21.7587 29.7211 21.161 28.9838 21.161V23.831ZM15.9919 22.496V21.161C15.2546 21.161 14.6569 21.7587 14.6569 22.496H15.9919ZM19.2398 23.831C19.9771 23.831 20.5749 23.2333 20.5749 22.496C20.5749 21.7587 19.9771 21.161 19.2398 21.161V23.831ZM14.6569 28.9919C14.6569 29.7292 15.2546 30.3269 15.9919 30.3269C16.7292 30.3269 17.3269 29.7292 17.3269 28.9919H14.6569ZM17.3269 11.1281C17.3269 10.3908 16.7292 9.7931 15.9919 9.7931C15.2546 9.7931 14.6569 10.3908 14.6569 11.1281H17.3269ZM15.9919 16.0001H14.6569C14.6569 16.7374 15.2546 17.3351 15.9919 17.3351V16.0001ZM22.4878 27.6569C21.7505 27.6569 21.1528 28.2546 21.1528 28.9919C21.1528 29.7292 21.7505 30.3269 22.4878 30.3269V27.6569ZM28.9838 30.3269C29.7211 30.3269 30.3188 29.7292 30.3188 28.9919C30.3188 28.2546 29.7211 27.6569 28.9838 27.6569V30.3269ZM3 14.6651C2.2627 14.6651 1.665 15.2628 1.665 16.0001C1.665 16.7374 2.2627 17.3351 3 17.3351V14.6651ZM9.49594 17.3351C10.2332 17.3351 10.8309 16.7374 10.8309 16.0001C10.8309 15.2628 10.2332 14.6651 9.49594 14.6651V17.3351ZM16.0081 17.3351C16.7454 17.3351 17.3431 16.7374 17.3431 16.0001C17.3431 15.2628 16.7454 14.6651 16.0081 14.6651V17.3351ZM22.5041 17.3351C23.2414 17.3351 23.8391 16.7374 23.8391 16.0001C23.8391 15.2628 23.2414 14.6651 22.5041 14.6651V17.3351ZM28.9838 14.6651C28.2465 14.6651 27.6488 15.2628 27.6488 16.0001C27.6488 16.7374 28.2465 17.3351 28.9838 17.3351V14.6651ZM29 17.3351C29.7373 17.3351 30.335 16.7374 30.335 16.0001C30.335 15.2628 29.7373 14.6651 29 14.6651V17.3351ZM4.62398 4.34318H7.87195V1.67318H4.62398V4.34318ZM8.16094 4.63216V7.88013H10.8309V4.63216H8.16094ZM7.87195 8.16912H4.62398V10.8391H7.87195V8.16912ZM4.335 7.88013V4.63216H1.665V7.88013H4.335ZM4.62398 8.16912C4.46438 8.16912 4.335 8.03974 4.335 7.88013H1.665C1.665 9.51434 2.98978 10.8391 4.62398 10.8391V8.16912ZM8.16094 7.88013C8.16094 8.03974 8.03156 8.16912 7.87195 8.16912V10.8391C9.50616 10.8391 10.8309 9.51434 10.8309 7.88013H8.16094ZM7.87195 4.34318C8.03156 4.34318 8.16094 4.47256 8.16094 4.63216H10.8309C10.8309 2.99796 9.50616 1.67318 7.87195 1.67318V4.34318ZM4.62398 1.67318C2.98978 1.67318 1.665 2.99796 1.665 4.63216H4.335C4.335 4.47256 4.46438 4.34318 4.62398 4.34318V1.67318ZM24.1118 4.34318H27.3598V1.67318H24.1118V4.34318ZM27.6488 4.63216V7.88013H30.3188V4.63216H27.6488ZM27.3598 8.16912H24.1118V10.8391H27.3598V8.16912ZM23.8228 7.88013V4.63216H21.1528V7.88013H23.8228ZM24.1118 8.16912C23.9522 8.16912 23.8228 8.03974 23.8228 7.88013H21.1528C21.1528 9.51434 22.4776 10.8391 24.1118 10.8391V8.16912ZM27.6488 7.88013C27.6488 8.03974 27.5194 8.16912 27.3598 8.16912V10.8391C28.994 10.8391 30.3188 9.51434 30.3188 7.88013H27.6488ZM27.3598 4.34318C27.5194 4.34318 27.6488 4.47256 27.6488 4.63216H30.3188C30.3188 2.99796 28.994 1.67318 27.3598 1.67318V4.34318ZM24.1118 1.67318C22.4776 1.67318 21.1528 2.99796 21.1528 4.63216H23.8228C23.8228 4.47256 23.9522 4.34318 24.1118 4.34318V1.67318ZM4.62398 23.831H7.87195V21.161H4.62398V23.831ZM8.16094 24.12V27.368H10.8309V24.12H8.16094ZM7.87195 27.6569H4.62398V30.3269H7.87195V27.6569ZM4.335 27.368V24.12H1.665V27.368H4.335ZM4.62398 27.6569C4.46438 27.6569 4.335 27.5276 4.335 27.368H1.665C1.665 29.0022 2.98978 30.3269 4.62398 30.3269V27.6569ZM8.16094 27.368C8.16094 27.5276 8.03156 27.6569 7.87195 27.6569V30.3269C9.50616 30.3269 10.8309 29.0022 10.8309 27.368H8.16094ZM7.87195 23.831C8.03156 23.831 8.16094 23.9604 8.16094 24.12H10.8309C10.8309 22.4858 9.50616 21.161 7.87195 21.161V23.831ZM4.62398 21.161C2.98978 21.161 1.665 22.4858 1.665 24.12H4.335C4.335 23.9604 4.46438 23.831 4.62398 23.831V21.161ZM14.6569 3.00818V4.63216H17.3269V3.00818H14.6569ZM25.7358 23.831H28.9838V21.161H25.7358V23.831ZM15.9919 23.831H19.2398V21.161H15.9919V23.831ZM14.6569 22.496V28.9919H17.3269V22.496H14.6569ZM14.6569 11.1281V16.0001H17.3269V11.1281H14.6569ZM22.4878 30.3269H28.9838V27.6569H22.4878V30.3269ZM3 17.3351H9.49594V14.6651H3V17.3351ZM15.9919 17.3351H16.0081V14.6651H15.9919V17.3351ZM28.9838 17.3351H29V14.6651H28.9838V17.3351ZM15.9919 17.3351H22.5041V14.6651H15.9919V17.3351Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-reply'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.1111H17.4444C23.8264 13.1111 29 18.2847 29 24.6667V27.5556M3 13.1111L11.6667 21.7778M3 13.1111L11.6667 4.44446"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-plus-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11.6667V16M16 16V20.3333M16 16H20.3333M16 16H11.6667M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-rss'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.85714 3C18.1909 3 29 13.8091 29 27.1429M4.85714 14.1429C12.0368 14.1429 17.8571 19.9632 17.8571 27.1429M6.71429 27.1429C6.71429 28.1685 5.88281 29 4.85714 29C3.83147 29 3 28.1685 3 27.1429C3 26.1172 3.83147 25.2857 4.85714 25.2857C5.88281 25.2857 6.71429 26.1172 6.71429 27.1429Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-rewind'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.2435 14.6435C16.3391 15.3218 16.3391 16.6783 17.2435 17.3565L26.287 24.1391C27.4048 24.9775 29 24.1799 29 22.7826V9.21741C29 7.82012 27.4048 7.02251 26.287 7.86089L17.2435 14.6435Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3.67826 14.6435C2.77391 15.3218 2.77391 16.6783 3.67826 17.3565L12.7217 24.1391C13.8396 24.9775 15.4348 24.1799 15.4348 22.7826V9.21741C15.4348 7.82011 13.8396 7.02251 12.7217 7.86089L3.67826 14.6435Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-save-as'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 22.4999V25.3888C23.2222 26.9843 21.9288 28.2777 20.3333 28.2777H5.88889C4.2934 28.2777 3 26.9843 3 25.3888V15.2777C3 13.6822 4.2934 12.3888 5.88889 12.3888H8.77778M13.1111 6.61106H11.6667C10.0712 6.61106 8.77778 7.90446 8.77778 9.49995V19.6111C8.77778 21.2065 10.0712 22.4999 11.6667 22.4999H26.1111C27.7066 22.4999 29 21.2065 29 19.6111V9.49995C29 7.90446 27.7066 6.61106 26.1111 6.61106H24.6667M23.2222 12.3888L18.8889 16.7222M18.8889 16.7222L14.5556 12.3888M18.8889 16.7222L18.8889 3.72217"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-scissors'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.2596 19.4471L28.1875 27.375M16.8125 16L28.1875 4.625M16.8125 16L12.1346 20.6779M16.8125 16L12.1346 11.3221M12.1346 20.6779C11.2524 19.7957 10.0337 19.25 8.6875 19.25C5.99511 19.25 3.8125 21.4326 3.8125 24.125C3.8125 26.8174 5.99511 29 8.6875 29C11.3799 29 13.5625 26.8174 13.5625 24.125C13.5625 22.7788 13.0168 21.5601 12.1346 20.6779ZM12.1346 11.3221C13.0168 10.4399 13.5625 9.22119 13.5625 7.875C13.5625 5.18261 11.3799 3 8.6875 3C5.99511 3 3.8125 5.18261 3.8125 7.875C3.8125 10.5674 5.99511 12.75 8.6875 12.75C10.0337 12.75 11.2524 12.2043 12.1346 11.3221Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-minus'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 16H3" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-scale'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 7.33402L7.33305 8.77837M7.33305 8.77837L3 21.7775C5.56015 23.7034 9.10767 23.7034 11.6678 21.7775M7.33305 8.77837L11.6662 21.7775M7.33305 8.77837L15.9991 5.88967M24.6652 8.77837L28.9983 7.33402M24.6652 8.77837L20.3322 21.7775C22.8923 23.7034 26.4399 23.7034 29 21.7775M24.6652 8.77837L28.9984 21.7775M24.6652 8.77837L15.9991 5.88967M15.9991 3.00098V5.88967M15.9991 28.9993V5.88967M15.9991 28.9993H11.6661M15.9991 28.9993H20.3322"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-save'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 8.77779H5.88889C4.2934 8.77779 3 10.0712 3 11.6667V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V11.6667C29 10.0712 27.7066 8.77779 26.1111 8.77779H21.7778M20.3333 14.5556L16 18.8889M16 18.8889L11.6667 14.5556M16 18.8889L16 4.44446"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 5.88889C3 4.2934 4.2934 3 5.88889 3H10.6256C11.2473 3 11.7993 3.39784 11.9959 3.98767L14.1594 10.4782C14.3867 11.1601 14.078 11.9054 13.4351 12.2269L10.1746 13.8572C11.7667 17.3884 14.6116 20.2333 18.1428 21.8254L19.7731 18.5649C20.0946 17.922 20.8399 17.6133 21.5218 17.8406L28.0123 20.0041C28.6022 20.2007 29 20.7527 29 21.3744V26.1111C29 27.7066 27.7066 29 26.1111 29H24.6667C12.7005 29 3 19.2995 3 7.33333V5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-pencil-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.7059 6.05883H6.05882C4.36948 6.05883 3 7.42831 3 9.11765V25.9412C3 27.6305 4.36948 29 6.05882 29H22.8823C24.5717 29 25.9412 27.6305 25.9412 25.9412V18.2941M23.7783 3.89591C24.9728 2.70136 26.9095 2.70136 28.1041 3.89591C29.2986 5.09045 29.2986 7.02719 28.1041 8.22174L14.9729 21.3529H10.6471L10.6471 17.0271L23.7783 3.89591Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-search-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 21.7778L14.3803 17.6197M14.3803 17.6197C15.1645 18.4039 16.2478 18.8889 17.4444 18.8889C19.8377 18.8889 21.7778 16.9488 21.7778 14.5556C21.7778 12.1623 19.8377 10.2222 17.4444 10.2222C15.0512 10.2222 13.1111 12.1623 13.1111 14.5556C13.1111 15.7522 13.5961 16.8355 14.3803 17.6197ZM29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-share'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.21 17.9383C11.5022 17.3551 11.6667 16.6968 11.6667 16C11.6667 15.3032 11.5022 14.6449 11.21 14.0617M11.21 17.9383C10.4986 19.3585 9.02981 20.3333 7.33333 20.3333C4.9401 20.3333 3 18.3932 3 16C3 13.6068 4.9401 11.6667 7.33333 11.6667C9.02981 11.6667 10.4986 12.6415 11.21 14.0617M11.21 17.9383L20.79 22.7283M11.21 14.0617L20.79 9.27168M20.79 9.27168C21.5014 10.6918 22.9702 11.6667 24.6667 11.6667C27.0599 11.6667 29 9.72657 29 7.33333C29 4.9401 27.0599 3 24.6667 3C22.2734 3 20.3333 4.9401 20.3333 7.33333C20.3333 8.03009 20.4978 8.68844 20.79 9.27168ZM20.79 22.7283C20.4978 23.3116 20.3333 23.9699 20.3333 24.6667C20.3333 27.0599 22.2734 29 24.6667 29C27.0599 29 29 27.0599 29 24.6667C29 22.2734 27.0599 20.3333 24.6667 20.3333C22.9702 20.3333 21.5014 21.3082 20.79 22.7283Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-presentation-chart-bar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 16.7222V15.2777M16 16.7222V12.3888M21.7778 16.7222V9.49995M10.2222 28.2777L16 22.4999L21.7778 28.2777M3 3.72217H29M4.44444 3.72217H27.5556V21.0555C27.5556 21.8532 26.9089 22.4999 26.1111 22.4999H5.88889C5.09114 22.4999 4.44444 21.8532 4.44444 21.0555V3.72217Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shield-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 16.3133L14.5556 19.2022L20.3333 13.4244M28.4481 7.62402C28.1525 7.63902 27.8549 7.64661 27.5556 7.64661C23.1161 7.64661 19.0665 5.97764 15.9999 3.23291C12.9333 5.97753 8.88378 7.64643 4.44444 7.64643C4.14512 7.64643 3.84756 7.63884 3.55196 7.62385C3.19168 9.01574 3 10.4755 3 11.98C3 20.0566 8.52402 26.8431 16 28.7672C23.476 26.8431 29 20.0566 29 11.98C29 10.4755 28.8083 9.01586 28.4481 7.62402Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-server'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 16H26.1111M5.88889 16C4.2934 16 3 14.7066 3 13.1111V7.33335C3 5.73786 4.2934 4.44446 5.88889 4.44446H26.1111C27.7066 4.44446 29 5.73786 29 7.33335V13.1111C29 14.7066 27.7066 16 26.1111 16M5.88889 16C4.2934 16 3 17.2934 3 18.8889V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V18.8889C29 17.2934 27.7066 16 26.1111 16M23.2222 10.2222H23.2367M23.2222 21.7778H23.2367"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sort-ascending'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4.44446H21.7778M3 10.2222H16M3 16H11.6667M17.4444 16L23.2222 10.2222M23.2222 10.2222L29 16M23.2222 10.2222V27.5556"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shopping-bag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 14.5556V8.77778C21.7777 5.5868 19.1909 3 15.9999 3C12.8089 3 10.2221 5.5868 10.2221 8.77778V14.5556M5.88878 11.6667H26.111L27.5554 29H4.44434L5.88878 11.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shield-exclamation'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11.98V14.8689M16 20.6467H16.0144M28.4481 7.62402C28.1525 7.63902 27.8549 7.64661 27.5556 7.64661C23.1161 7.64661 19.0665 5.97764 15.9999 3.23291C12.9333 5.97753 8.88378 7.64643 4.44444 7.64643C4.14512 7.64643 3.84756 7.63884 3.55196 7.62385C3.19168 9.01574 3 10.4755 3 11.98C3 20.0566 8.52402 26.8431 16 28.7672C23.476 26.8431 29 20.0566 29 11.98C29 10.4755 28.8083 9.01586 28.4481 7.62402Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shopping-cart'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 3H5.88889L6.46667 5.88889M8.77778 17.4444H23.2222L29 5.88889H6.46667M8.77778 17.4444L6.46667 5.88889M8.77778 17.4444L5.46582 20.7564C4.55587 21.6663 5.20033 23.2222 6.4872 23.2222H23.2222M23.2222 23.2222C21.6267 23.2222 20.3333 24.5156 20.3333 26.1111C20.3333 27.7066 21.6267 29 23.2222 29C24.8177 29 26.1111 27.7066 26.1111 26.1111C26.1111 24.5156 24.8177 23.2222 23.2222 23.2222ZM11.6667 26.1111C11.6667 27.7066 10.3733 29 8.77778 29C7.18229 29 5.88889 27.7066 5.88889 26.1111C5.88889 24.5156 7.18229 23.2222 8.77778 23.2222C10.3733 23.2222 11.6667 24.5156 11.6667 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sm-view-grid-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24.125 19.25V29M19.25 24.125H29M6.25 12.75H9.5C11.2949 12.75 12.75 11.2949 12.75 9.5V6.25C12.75 4.45507 11.2949 3 9.5 3H6.25C4.45507 3 3 4.45507 3 6.25V9.5C3 11.2949 4.45507 12.75 6.25 12.75ZM22.5 12.75H25.75C27.5449 12.75 29 11.2949 29 9.5V6.25C29 4.45507 27.5449 3 25.75 3H22.5C20.7051 3 19.25 4.45507 19.25 6.25V9.5C19.25 11.2949 20.7051 12.75 22.5 12.75ZM6.25 29H9.5C11.2949 29 12.75 27.5449 12.75 25.75V22.5C12.75 20.7051 11.2949 19.25 9.5 19.25H6.25C4.45507 19.25 3 20.7051 3 22.5V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sort-descending'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4.44446H21.7778M3 10.2222H16M3 16H16M23.2222 10.2222V27.5556M23.2222 27.5556L17.4444 21.7778M23.2222 27.5556L29 21.7778"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-speakerphone'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 7.16315V26.458C14.5556 27.8619 13.4175 29 12.0136 29C10.9393 29 9.98103 28.3247 9.61972 27.313L6.51935 18.4308M24.6667 17.4444C27.0599 17.4444 29 15.5043 29 13.1111C29 10.7179 27.0599 8.77778 24.6667 8.77778M6.51935 18.4308C4.45065 17.5515 3 15.5007 3 13.1111C3 9.92013 5.58679 7.33333 8.77777 7.33333H11.4241C17.3473 7.33333 22.4377 5.55075 24.6667 3L24.6667 23.2222C22.4377 20.6715 17.3473 18.8889 11.4241 18.8889L8.77774 18.8889C7.97637 18.8889 7.21311 18.7257 6.51935 18.4308Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-star'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.049 5.92664C15.3483 5.00538 16.6517 5.00538 16.951 5.92664L18.6944 11.2915C18.8283 11.7035 19.2122 11.9824 19.6454 11.9824L25.2864 11.9827C26.2551 11.9827 26.6579 13.2222 25.8742 13.7917L21.3107 17.1075C20.9602 17.3622 20.8136 17.8135 20.9474 18.2255L22.6904 23.5905C22.9897 24.5118 21.9353 25.2779 21.1516 24.7085L16.5878 21.393C16.2373 21.1384 15.7627 21.1384 15.4122 21.393L10.8484 24.7085C10.0647 25.2779 9.01031 24.5118 9.30962 23.5905L11.0526 18.2255C11.1864 17.8135 11.0398 17.3622 10.6893 17.1075L6.12578 13.7917C5.34211 13.2222 5.74487 11.9827 6.71355 11.9827L12.3546 11.9824C12.7878 11.9824 13.1717 11.7035 13.3056 11.2915L15.049 5.92664Z"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-search'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 29L20.3333 20.3333M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-selector'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.57153 10.4286L16.0001 3L23.4287 10.4286M23.4287 21.5714L16.0001 29L8.57153 21.5714"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-switch-vertical'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 21.7777V4.44434M8.77778 4.44434L3 10.2221M8.77778 4.44434L14.5556 10.2221M23.2222 10.2221V27.5554M23.2222 27.5554L29 21.7777M23.2222 27.5554L17.4444 21.7777"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-support'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M27.665 16C27.665 22.4424 22.4424 27.665 16 27.665V30.335C23.917 30.335 30.335 23.917 30.335 16H27.665ZM16 27.665C9.5576 27.665 4.335 22.4424 4.335 16H1.665C1.665 23.917 8.083 30.335 16 30.335V27.665ZM4.335 16C4.335 9.5576 9.5576 4.335 16 4.335V1.665C8.083 1.665 1.665 8.083 1.665 16H4.335ZM16 4.335C22.4424 4.335 27.665 9.5576 27.665 16H30.335C30.335 8.083 23.917 1.665 16 1.665V4.335ZM20.4428 16C20.4428 18.4537 18.4537 20.4428 16 20.4428V23.1128C19.9283 23.1128 23.1128 19.9283 23.1128 16H20.4428ZM16 20.4428C13.5463 20.4428 11.5572 18.4537 11.5572 16H8.88722C8.88722 19.9283 12.0717 23.1128 16 23.1128V20.4428ZM11.5572 16C11.5572 13.5463 13.5463 11.5572 16 11.5572V8.88722C12.0717 8.88722 8.88722 12.0717 8.88722 16H11.5572ZM16 11.5572C18.4537 11.5572 20.4428 13.5463 20.4428 16H23.1128C23.1128 12.0717 19.9283 8.88722 16 8.88722V11.5572ZM24.2484 5.86362L19.1415 10.9705L21.0295 12.8585L26.1364 7.7516L24.2484 5.86362ZM19.1415 21.0295L24.2484 26.1364L26.1364 24.2484L21.0295 19.1415L19.1415 21.0295ZM12.8585 10.9705L7.7516 5.86362L5.86362 7.7516L10.9705 12.8585L12.8585 10.9705ZM10.9705 19.1415L5.86362 24.2484L7.7516 26.1364L12.8585 21.0295L10.9705 19.1415Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-switch-horizontal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2223 8.77778H27.5557M27.5557 8.77778L21.7779 3M27.5557 8.77778L21.7779 14.5556M21.7779 23.2222H4.44455M4.44455 23.2222L10.2223 29M4.44455 23.2222L10.2223 17.4444"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sparkles'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 3V8.77778M3 5.88889H8.77778M7.33333 23.2222V29M4.44444 26.1111H10.2222M17.4444 3L20.746 12.9048L29 16L20.746 19.0952L17.4444 29L14.1429 19.0952L5.88889 16L14.1429 12.9048L17.4444 3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-question-mark-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5511 11.6667C11.3442 9.98361 13.4844 8.77778 16.0001 8.77778C19.1911 8.77778 21.7779 10.7179 21.7779 13.1111C21.7779 15.1325 19.9324 16.8307 17.4362 17.3095C16.6527 17.4598 16.0001 18.0911 16.0001 18.8889M16 23.2222H16.0144M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-status-online'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80761 25.1924C1.7308 20.1156 1.7308 11.8844 6.80761 6.80762M25.1924 6.80762C30.2692 11.8844 30.2692 20.1156 25.1924 25.1924M10.8931 21.1069C8.07266 18.2864 8.07266 13.7136 10.8931 10.8931M21.1069 10.8931C23.9273 13.7136 23.9273 18.2864 21.1069 21.1069M17.4444 16C17.4444 16.7978 16.7977 17.4444 16 17.4444C15.2023 17.4444 14.5556 16.7978 14.5556 16C14.5556 15.2023 15.2023 14.5556 16 14.5556C16.7977 14.5556 17.4444 15.2023 17.4444 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-tag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.1667 3.97802L17.1658 4.86143C17.1841 4.88221 17.2031 4.90241 17.2227 4.922L18.1667 3.97802ZM28.022 18.1667L27.1386 17.1658C27.1178 17.1841 27.0976 17.2031 27.078 17.2227L28.022 18.1667ZM28.2778 14.0891L29.2787 13.2057C29.2603 13.1849 29.2414 13.1647 29.2218 13.1451L28.2778 14.0891ZM14.0891 28.2778L13.1451 29.2218C13.1647 29.2414 13.1849 29.2603 13.2057 29.2787L14.0891 28.2778ZM17.9109 28.2778L18.7943 29.2787C18.8151 29.2603 18.8353 29.2414 18.8549 29.2218L17.9109 28.2778ZM3.97802 18.1667L4.922 17.2227L4.8926 17.1933L4.86143 17.1658L3.97802 18.1667ZM8.77778 7.44278C8.04048 7.44278 7.44278 8.04048 7.44278 8.77778C7.44278 9.51508 8.04048 10.1128 8.77778 10.1128V7.44278ZM8.79222 10.1128C9.52952 10.1128 10.1272 9.51508 10.1272 8.77778C10.1272 8.04048 9.52952 7.44278 8.79222 7.44278V10.1128ZM4.335 8.77778C4.335 6.3241 6.3241 4.335 8.77778 4.335V1.665C4.8495 1.665 1.665 4.8495 1.665 8.77778H4.335ZM4.335 16V8.77778H1.665V16H4.335ZM8.77778 4.335H16V1.665H8.77778V4.335ZM16 4.335C16.4639 4.335 16.8791 4.53662 17.1658 4.86143L19.1676 3.0946C18.3956 2.21991 17.2618 1.665 16 1.665V4.335ZM27.665 16C27.665 16.4639 27.4634 16.8791 27.1386 17.1658L28.9054 19.1676C29.7801 18.3956 30.335 17.2617 30.335 16H27.665ZM27.2769 14.9725C27.5194 15.2473 27.665 15.605 27.665 16H30.335C30.335 14.9297 29.9352 13.9495 29.2787 13.2057L27.2769 14.9725ZM16 27.665C15.605 27.665 15.2473 27.5194 14.9725 27.2769L13.2057 29.2787C13.9495 29.9352 14.9297 30.335 16 30.335V27.665ZM17.0275 27.2769C16.7527 27.5194 16.395 27.665 16 27.665V30.335C17.0703 30.335 18.0505 29.9352 18.7943 29.2787L17.0275 27.2769ZM4.86143 17.1658C4.53662 16.8791 4.335 16.4639 4.335 16H1.665C1.665 17.2618 2.21991 18.3956 3.0946 19.1676L4.86143 17.1658ZM17.2227 4.922L27.3338 15.0331L29.2218 13.1451L19.1107 3.03403L17.2227 4.922ZM15.0331 27.3338L4.922 17.2227L3.03403 19.1107L13.1451 29.2218L15.0331 27.3338ZM27.078 17.2227L16.9669 27.3338L18.8549 29.2218L28.966 19.1107L27.078 17.2227ZM8.77778 10.1128H8.79222V7.44278H8.77778V10.1128Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-status-offline'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1364 5.86364C25.615 5.34229 24.7698 5.34229 24.2484 5.86364C23.7271 6.38499 23.7271 7.23026 24.2484 7.75161L26.1364 5.86364ZM25.1924 25.1924L24.2484 26.1364H24.2484L25.1924 25.1924ZM22.0509 9.94914C21.5295 9.42779 20.6842 9.42779 20.1629 9.94914C19.6415 10.4705 19.6415 11.3158 20.1629 11.8371L22.0509 9.94914ZM21.1069 21.1069L20.1629 22.0509L20.1629 22.0509L21.1069 21.1069ZM9.94913 22.0509C10.4705 22.5722 11.3158 22.5722 11.8371 22.0509C12.3585 21.5295 12.3585 20.6843 11.8371 20.1629L9.94913 22.0509ZM10.1716 16.8332C10.068 16.1032 9.39216 15.5955 8.66219 15.6991C7.93221 15.8028 7.42447 16.4786 7.52812 17.2086L10.1716 16.8332ZM5.86362 26.1364C6.38497 26.6577 7.23025 26.6577 7.7516 26.1364C8.27295 25.615 8.27295 24.7698 7.7516 24.2484L5.86362 26.1364ZM4.94309 12.2739C5.17795 11.575 4.80177 10.818 4.10288 10.5832C3.40398 10.3483 2.64703 10.7245 2.41217 11.4234L4.94309 12.2739ZM3.94399 2.05601C3.42264 1.53466 2.57736 1.53466 2.05601 2.05601C1.53466 2.57736 1.53466 3.42264 2.05601 3.94399L3.94399 2.05601ZM28.056 29.944C28.5774 30.4653 29.4226 30.4653 29.944 29.944C30.4653 29.4226 30.4653 28.5774 29.944 28.056L28.056 29.944ZM24.2484 7.75161C28.8039 12.3071 28.8039 19.6929 24.2484 24.2484L26.1364 26.1364C31.7345 20.5382 31.7345 11.4618 26.1364 5.86364L24.2484 7.75161ZM20.1629 11.8371C22.462 14.1362 22.462 17.8638 20.1629 20.1629L22.0509 22.0509C25.3927 18.7091 25.3927 13.2909 22.0509 9.94914L20.1629 11.8371ZM16 15.8906C16.0604 15.8906 16.1094 15.9396 16.1094 16H18.7794C18.7794 14.465 17.535 13.2206 16 13.2206V15.8906ZM11.8371 20.1629C10.8987 19.2245 10.3446 18.0517 10.1716 16.8332L7.52812 17.2086C7.77966 18.98 8.58777 20.6895 9.94913 22.0509L11.8371 20.1629ZM7.7516 24.2484C4.51436 21.0112 3.57569 16.343 4.94309 12.2739L2.41217 11.4234C0.734353 16.4162 1.88234 22.1551 5.86362 26.1364L7.7516 24.2484ZM15.9226 15.9226C15.9335 15.9117 15.9457 15.9037 15.9578 15.8986C15.969 15.8939 15.9824 15.8906 16 15.8906V13.2206C15.2329 13.2206 14.5362 13.5331 14.0346 14.0346L15.9226 15.9226ZM2.05601 3.94399L14.0346 15.9226L15.9226 14.0346L3.94399 2.05601L2.05601 3.94399ZM14.0346 15.9226L16.0774 17.9654L17.9654 16.0774L15.9226 14.0346L14.0346 15.9226ZM16.0774 17.9654L20.1629 22.0509L22.0509 20.1629L17.9654 16.0774L16.0774 17.9654ZM20.1629 22.0509L24.2484 26.1364L26.1364 24.2484L22.0509 20.1629L20.1629 22.0509ZM24.2484 26.1364L28.056 29.944L29.944 28.056L26.1364 24.2484L24.2484 26.1364ZM16.1094 16C16.1094 16.0176 16.1061 16.031 16.1014 16.0422C16.0963 16.0543 16.0883 16.0665 16.0774 16.0774L17.9654 17.9654C18.4669 17.4638 18.7794 16.7672 18.7794 16H16.1094Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-printer'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 23.2222H26.1111C27.7066 23.2222 29 21.9288 29 20.3333V14.5556C29 12.9601 27.7066 11.6667 26.1111 11.6667H5.88889C4.2934 11.6667 3 12.9601 3 14.5556V20.3333C3 21.9288 4.2934 23.2222 5.88889 23.2222H8.77778M11.6667 29H20.3333C21.9288 29 23.2222 27.7066 23.2222 26.1111V20.3333C23.2222 18.7378 21.9288 17.4444 20.3333 17.4444H11.6667C10.0712 17.4444 8.77778 18.7378 8.77778 20.3333V26.1111C8.77778 27.7066 10.0712 29 11.6667 29ZM23.2222 11.6667V5.88889C23.2222 4.2934 21.9288 3 20.3333 3H11.6667C10.0712 3 8.77778 4.2934 8.77778 5.88889V11.6667H23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-table'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.1112H29M3 18.8889H29M16 13.1112V24.6667M5.88889 24.6667H26.1111C27.7066 24.6667 29 23.3733 29 21.7778V10.2223C29 8.62677 27.7066 7.33337 26.1111 7.33337H5.88889C4.2934 7.33337 3 8.62677 3 10.2223V21.7778C3 23.3733 4.2934 24.6667 5.88889 24.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-template'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4.625C3 3.72754 3.72754 3 4.625 3H27.375C28.2725 3 29 3.72754 29 4.625V7.875C29 8.77246 28.2725 9.5 27.375 9.5H4.625C3.72754 9.5 3 8.77246 3 7.875V4.625Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3 17.625C3 16.7275 3.72754 16 4.625 16H14.375C15.2725 16 16 16.7275 16 17.625V27.375C16 28.2725 15.2725 29 14.375 29H4.625C3.72754 29 3 28.2725 3 27.375V17.625Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M22.5 17.625C22.5 16.7275 23.2275 16 24.125 16H27.375C28.2725 16 29 16.7275 29 17.625V27.375C29 28.2725 28.2725 29 27.375 29H24.125C23.2275 29 22.5 28.2725 22.5 27.375V17.625Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-terminal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 11.6667L14.5556 16L10.2222 20.3333M17.4444 20.3333H21.7778M5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V7.33335C29 5.73786 27.7066 4.44446 26.1111 4.44446H5.88889C4.2934 4.44446 3 5.73786 3 7.33335V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-thumb-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0576 18.8889H25.9388C28.0864 18.8889 29.4831 16.6289 28.5227 14.708L23.4672 4.59694C22.9778 3.61823 21.9775 3 20.8833 3H15.0799C14.8437 3 14.6084 3.02897 14.3792 3.08626L8.94648 4.44444M19.0576 18.8889V26.1111C19.0576 27.7066 17.7642 29 16.1687 29H16.0308C15.3092 29 14.7243 28.415 14.7243 27.6935C14.7243 26.6617 14.4189 25.653 13.8465 24.7945L8.94648 17.4444V4.44444M19.0576 18.8889H16.1687M8.94648 4.44444H6.05759C4.4621 4.44444 3.1687 5.73784 3.1687 7.33333V16C3.1687 17.5955 4.4621 18.8889 6.05759 18.8889H9.6687"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-trending-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 23.2223H29M29 23.2223V11.6667M29 23.2223L17.4444 11.6667L11.6667 17.4445L3 8.77783"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-thumb-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0575 13.1111H25.9387C28.0863 13.1111 29.4831 15.3711 28.5226 17.292L23.4671 27.4031C22.9777 28.3818 21.9774 29 20.8832 29H15.0798C14.8436 29 14.6083 28.971 14.3792 28.9137L8.9464 27.5556M19.0575 13.1111V5.88889C19.0575 4.2934 17.7641 3 16.1686 3H16.0307C15.3091 3 14.7242 3.58496 14.7242 4.30654C14.7242 5.33831 14.4188 6.347 13.8464 7.20549L8.9464 14.5556V27.5556M19.0575 13.1111H16.1686M8.9464 27.5556H6.05751C4.46202 27.5556 3.16862 26.2622 3.16862 24.6667V16C3.16862 14.4045 4.46202 13.1111 6.05751 13.1111H9.66862"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-translate'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 5.88889H20.3333M11.6667 3V5.88889M13.1807 19.6111C10.9745 17.3257 9.18327 14.6371 7.92825 11.6667M16.7222 24.6667H26.8333M14.5556 29L21.7778 14.5556L29 29M17.085 5.88889C15.6867 14.2237 10.3229 21.2138 3 24.8529"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-trash'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.111 8.77778L24.8582 26.3169C24.7502 27.8287 23.4923 29 21.9767 29H10.0231C8.5075 29 7.24956 27.8287 7.14158 26.3169L5.88878 8.77778M13.111 14.5556V23.2222M18.8888 14.5556V23.2222M20.3332 8.77778V4.44444C20.3332 3.6467 19.6865 3 18.8888 3H13.111C12.3133 3 11.6666 3.6467 11.6666 4.44444V8.77778M4.44434 8.77778H27.5554"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-truck'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 21.7778V7.33336C17.4444 6.53562 16.7977 5.88892 16 5.88892H4.44444C3.6467 5.88892 3 6.53562 3 7.33336V21.7778C3 22.5755 3.6467 23.2222 4.44444 23.2222H5.88889M17.4444 21.7778C17.4444 22.5755 16.7977 23.2222 16 23.2222H11.6667M17.4444 21.7778L17.4444 10.2222C17.4444 9.4245 18.0911 8.7778 18.8889 8.7778H22.6239C23.007 8.7778 23.3744 8.92999 23.6453 9.20087L28.5769 14.1325C28.8478 14.4034 29 14.7708 29 15.1539V21.7778C29 22.5755 28.3533 23.2222 27.5556 23.2222H26.1111M17.4444 21.7778C17.4444 22.5755 18.0911 23.2222 18.8889 23.2222H20.3333M5.88889 23.2222C5.88889 24.8177 7.18229 26.1111 8.77778 26.1111C10.3733 26.1111 11.6667 24.8177 11.6667 23.2222M5.88889 23.2222C5.88889 21.6268 7.18229 20.3334 8.77778 20.3334C10.3733 20.3334 11.6667 21.6268 11.6667 23.2222M20.3333 23.2222C20.3333 24.8177 21.6267 26.1111 23.2222 26.1111C24.8177 26.1111 26.1111 24.8177 26.1111 23.2222M20.3333 23.2222C20.3333 21.6268 21.6267 20.3334 23.2222 20.3334C24.8177 20.3334 26.1111 21.6268 26.1111 23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24.6667 11.6667V16M24.6667 16V20.3333M24.6667 16H29M24.6667 16H20.3333M17.4444 8.77778C17.4444 11.9688 14.8576 14.5556 11.6667 14.5556C8.47569 14.5556 5.88889 11.9688 5.88889 8.77778C5.88889 5.5868 8.47569 3 11.6667 3C14.8576 3 17.4444 5.5868 17.4444 8.77778ZM3 27.5556C3 22.7691 6.8802 18.8889 11.6667 18.8889C16.4531 18.8889 20.3333 22.7691 20.3333 27.5556V29H3V27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-trending-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 8.77783H29M29 8.77783V20.3334M29 8.77783L17.4444 20.3334L11.6667 14.5556L3 23.2223"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7778 8.77778C21.7778 11.9688 19.191 14.5556 16 14.5556C12.809 14.5556 10.2222 11.9688 10.2222 8.77778C10.2222 5.5868 12.809 3 16 3C19.191 3 21.7778 5.5868 21.7778 8.77778Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16 18.8889C10.4158 18.8889 5.88892 23.4158 5.88892 29H26.1111C26.1111 23.4158 21.5842 18.8889 16 18.8889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.06372 24.3832C8.9983 22.7245 12.3886 21.7778 16 21.7778C19.6114 21.7778 23.0017 22.7245 25.9363 24.3832M20.3333 13.1111C20.3333 15.5043 18.3932 17.4444 16 17.4444C13.6068 17.4444 11.6667 15.5043 11.6667 13.1111C11.6667 10.7179 13.6068 8.77778 16 8.77778C18.3932 8.77778 20.3333 10.7179 20.3333 13.1111ZM29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-variable'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.72211 4.36108C3.97972 7.86719 3 11.8192 3 16C3 20.1808 3.97972 24.1328 5.72211 27.6389M26.2779 27.6389C28.0203 24.1328 29 20.1808 29 16C29 11.8192 28.0203 7.86719 26.2779 4.36108M11.7292 11.6354H13.5415C14.1911 11.6354 14.7619 12.066 14.9404 12.6906L17.2472 20.7643C17.4256 21.3888 17.9965 21.8194 18.646 21.8194H20.4584M21.9132 11.6354H21.7966C20.9472 11.6354 20.1402 12.0066 19.5874 12.6515L12.6001 20.8033C12.0473 21.4483 11.2403 21.8194 10.3909 21.8194H10.2743"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sun'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 3V4.44444M16 27.5556V29M29 16H27.5556M4.44444 16H3M25.1924 25.1924L24.171 24.171M7.82899 7.82899L6.80761 6.80761M25.1925 6.80769L24.1711 7.82907M7.82906 24.1711L6.80769 25.1925M21.7778 16C21.7778 19.191 19.191 21.7778 16 21.7778C12.809 21.7778 10.2222 19.191 10.2222 16C10.2222 12.809 12.809 10.2222 16 10.2222C19.191 10.2222 21.7778 12.809 21.7778 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-view-boards'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 23.2222V8.7778M11.6667 23.2222C11.6667 24.8177 10.3733 26.1111 8.77778 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H8.77778C10.3733 5.88892 11.6667 7.18232 11.6667 8.7778M11.6667 23.2222C11.6667 24.8177 12.9601 26.1111 14.5556 26.1111H17.4444C19.0399 26.1111 20.3333 24.8177 20.3333 23.2222M11.6667 8.7778C11.6667 7.18232 12.9601 5.88892 14.5556 5.88892H17.4444C19.0399 5.88892 20.3333 7.18232 20.3333 8.7778M20.3333 23.2222V8.7778M20.3333 23.2222C20.3333 24.8177 21.6267 26.1111 23.2222 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H23.2222C21.6267 5.88892 20.3333 7.18232 20.3333 8.7778"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-ticket'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 5.88892V8.7778M20.3333 14.5556V17.4445M20.3333 23.2222V26.1111M5.88889 5.88892C4.2934 5.88892 3 7.18232 3 8.7778V13.1111C4.59549 13.1111 5.88889 14.4045 5.88889 16C5.88889 17.5955 4.59549 18.8889 3 18.8889V23.2222C3 24.8177 4.2934 26.1111 5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V18.8889C27.4045 18.8889 26.1111 17.5955 26.1111 16C26.1111 14.4045 27.4045 13.1111 29 13.1111V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-view-list'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 6.25H29M3 12.75H29M3 19.25H29M3 25.75H29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user-group'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 26.4001H29V23.8001C29 21.6462 27.2539 19.9001 25.1 19.9001C23.8577 19.9001 22.7511 20.4809 22.0369 21.3859M22.5 26.4001H9.5M22.5 26.4001V23.8001C22.5 22.947 22.3356 22.1323 22.0369 21.3859M9.5 26.4001H3V23.8001C3 21.6462 4.74609 19.9001 6.9 19.9001C8.14229 19.9001 9.24892 20.4809 9.96312 21.3859M9.5 26.4001V23.8001C9.5 22.947 9.66435 22.1323 9.96312 21.3859M9.96312 21.3859C10.9216 18.9914 13.2633 17.3001 16 17.3001C18.7367 17.3001 21.0784 18.9914 22.0369 21.3859M19.9 9.5001C19.9 11.654 18.1539 13.4001 16 13.4001C13.8461 13.4001 12.1 11.654 12.1 9.5001C12.1 7.34619 13.8461 5.6001 16 5.6001C18.1539 5.6001 19.9 7.34619 19.9 9.5001ZM27.7 13.4001C27.7 14.836 26.5359 16.0001 25.1 16.0001C23.6641 16.0001 22.5 14.836 22.5 13.4001C22.5 11.9642 23.6641 10.8001 25.1 10.8001C26.5359 10.8001 27.7 11.9642 27.7 13.4001ZM9.5 13.4001C9.5 14.836 8.33594 16.0001 6.9 16.0001C5.46406 16.0001 4.3 14.836 4.3 13.4001C4.3 11.9642 5.46406 10.8001 6.9 10.8001C8.33594 10.8001 9.5 11.9642 9.5 13.4001Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-volume-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.1068 10.8931C23.9273 13.7136 23.9273 18.2864 21.1068 21.1069M25.1924 6.80756C30.2692 11.8844 30.2692 20.1155 25.1924 25.1923M6.73501 20.3334H4.44444C3.6467 20.3334 3 19.6867 3 18.8889V13.1112C3 12.3134 3.6467 11.6667 4.44444 11.6667H6.73501L13.5341 4.86761C14.4441 3.95767 16 4.60213 16 5.88899V26.1111C16 27.398 14.4441 28.0425 13.5341 27.1325L6.73501 20.3334Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-video-camera'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 13.1112L26.9096 9.82303C27.87 9.34282 29 10.0412 29 11.115V20.8851C29 21.9589 27.87 22.6573 26.9096 22.177L20.3333 18.8889M5.88889 24.6667H17.4444C19.0399 24.6667 20.3333 23.3733 20.3333 21.7778V10.2223C20.3333 8.62677 19.0399 7.33337 17.4444 7.33337H5.88889C4.2934 7.33337 3 8.62677 3 10.2223V21.7778C3 23.3733 4.2934 24.6667 5.88889 24.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-volume-off'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 18.8889L26.1111 16M26.1111 16L29 13.1111M26.1111 16L23.2222 13.1111M26.1111 16L29 18.8889M6.73502 20.3334H4.44444C3.6467 20.3334 3 19.6867 3 18.889V13.1112C3 12.3135 3.6467 11.6668 4.44444 11.6668H6.73502L13.5342 4.86761C14.4441 3.95766 16 4.60213 16 5.88899V26.1112C16 27.3981 14.4441 28.0425 13.5342 27.1326L6.73502 20.3334Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-view-grid'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 6.25C3 4.45507 4.45507 3 6.25 3H9.5C11.2949 3 12.75 4.45507 12.75 6.25V9.5C12.75 11.2949 11.2949 12.75 9.5 12.75H6.25C4.45507 12.75 3 11.2949 3 9.5V6.25Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.25 6.25C19.25 4.45507 20.7051 3 22.5 3H25.75C27.5449 3 29 4.45507 29 6.25V9.5C29 11.2949 27.5449 12.75 25.75 12.75H22.5C20.7051 12.75 19.25 11.2949 19.25 9.5V6.25Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3 22.5C3 20.7051 4.45507 19.25 6.25 19.25H9.5C11.2949 19.25 12.75 20.7051 12.75 22.5V25.75C12.75 27.5449 11.2949 29 9.5 29H6.25C4.45507 29 3 27.5449 3 25.75V22.5Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.25 22.5C19.25 20.7051 20.7051 19.25 22.5 19.25H25.75C27.5449 19.25 29 20.7051 29 22.5V25.75C29 27.5449 27.5449 29 25.75 29H22.5C20.7051 29 19.25 27.5449 19.25 25.75V22.5Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-stop'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M11.6667 13.1111C11.6667 12.3134 12.3134 11.6667 13.1111 11.6667H18.8889C19.6866 11.6667 20.3333 12.3134 20.3333 13.1111V18.8889C20.3333 19.6866 19.6866 20.3333 18.8889 20.3333H13.1111C12.3134 20.3333 11.6667 19.6866 11.6667 18.8889V13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-users'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 4.95603C17.0587 3.75653 18.6077 3 20.3333 3C23.5243 3 26.1111 5.5868 26.1111 8.77778C26.1111 11.9688 23.5243 14.5556 20.3333 14.5556C18.6077 14.5556 17.0587 13.799 16 12.5995M20.3333 29H3V27.5556C3 22.7691 6.8802 18.8889 11.6667 18.8889C16.4531 18.8889 20.3333 22.7691 20.3333 27.5556V29ZM20.3333 29H29V27.5556C29 22.7691 25.1198 18.8889 20.3333 18.8889C18.7548 18.8889 17.2748 19.3109 16 20.0483M17.4444 8.77778C17.4444 11.9688 14.8576 14.5556 11.6667 14.5556C8.47569 14.5556 5.88889 11.9688 5.88889 8.77778C5.88889 5.5868 8.47569 3 11.6667 3C14.8576 3 17.4444 5.5868 17.4444 8.77778Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-x'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 29L29 3M3 3L29 29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-wifi'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.2333 20.7848C13.8659 18.1522 18.1341 18.1522 20.7667 20.7848M16 25.1924H16.0123M7.33338 16.5257C12.1198 11.7393 19.8802 11.7393 24.6667 16.5257M3 12.1924C10.1797 5.01269 21.8203 5.01269 29 12.1924"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-x-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 18.8889L16 16M16 16L18.8889 13.1111M16 16L13.1111 13.1111M16 16L18.8889 18.8889M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-upload'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 22.5L3 24.125C3 26.8174 5.18261 29 7.875 29L24.125 29C26.8174 29 29 26.8174 29 24.125L29 22.5M22.5 9.5L16 3M16 3L9.5 9.5M16 3L16 22.5"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-zoom-out'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 29L20.3333 20.3333M17.4444 13.1111H8.77778M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-saving'">
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.6667 28.8018H9.33333M22.6667 28.8018H23.7373C25.228 28.8018 25.9733 28.8018 26.5427 28.5111C27.0453 28.2551 27.4533 27.8471 27.7093 27.3458C28 26.7764 28 26.0298 28 24.5391V13.0951C28 12.4951 28 12.1951 27.936 11.9098C27.8793 11.6552 27.7854 11.4103 27.6573 11.1831C27.516 10.9298 27.316 10.7098 26.924 10.2738L23.2507 6.19109C22.796 5.68709 22.5653 5.43109 22.2893 5.24709C22.0404 5.08191 21.7654 4.95977 21.476 4.88576C21.1507 4.80176 20.8 4.80176 20.1 4.80176H8.26667C6.77333 4.80176 6.02667 4.80176 5.456 5.09242C4.9542 5.34801 4.54625 5.75596 4.29067 6.25776C4 6.82842 4 7.57509 4 9.06842V24.5351C4 26.0284 4 26.7751 4.29067 27.3444C4.54667 27.8471 4.95333 28.2551 5.456 28.5111C6.02533 28.8018 6.772 28.8018 8.26267 28.8018H9.33333M22.6667 28.8018V23.7311C22.6667 22.2404 22.6667 21.4938 22.376 20.9244C22.1199 20.4225 21.7115 20.0146 21.2093 19.7591C20.64 19.4684 19.8933 19.4684 18.4 19.4684H13.6C12.1067 19.4684 11.36 19.4684 10.7893 19.7591C10.2875 20.0147 9.87958 20.4226 9.624 20.9244C9.33333 21.4951 9.33333 22.2418 9.33333 23.7351V28.8018M20 10.1351H12"
                    stroke="#4B5563"
                    stroke-width="2.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-zoom-in'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 29L20.3333 20.3333M13.1111 8.77778V13.1111M13.1111 13.1111V17.4444M13.1111 13.1111H17.4444M13.1111 13.1111H8.77778M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-inactif'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2337_10824)">
                    <path
                        d="M13.3637 15.6353C16.2567 15.6353 18.6019 13.2901 18.6019 10.3971C18.6019 7.50416 16.2567 5.15894 13.3637 5.15894C10.4707 5.15894 8.12549 7.50416 8.12549 10.3971C8.12549 13.2901 10.4707 15.6353 13.3637 15.6353Z"
                        stroke="black"
                        stroke-width="2.31779"
                        stroke-miterlimit="10"
                    />
                    <path
                        d="M21.526 27.7341C21.5547 27.4875 21.5686 27.2381 21.5686 26.985C21.5686 22.9177 17.8954 19.6218 13.3637 19.6218C8.83192 19.6218 5.15869 22.9186 5.15869 26.985C5.15869 27.2381 5.1726 27.4875 5.20134 27.7341"
                        stroke="black"
                        stroke-width="2.31779"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                    />
                    <path d="M21.917 14.3838L26.1381 18.604" stroke="black" stroke-width="2.03965" stroke-miterlimit="10" stroke-linecap="round" />
                    <path d="M26.1381 14.3838L21.917 18.604" stroke="black" stroke-width="2.03965" stroke-miterlimit="10" stroke-linecap="round" />
                </g>
                <defs>
                    <clipPath id="clip0_2337_10824">
                        <rect width="23.1584" height="24.893" fill="white" transform="translate(4 4)" />
                    </clipPath>
                </defs>
            </svg>
        </template>

        <template v-if="icon === 'design-system-vivier'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.9664 16.1601C13.205 16.1601 15.0198 14.3454 15.0198 12.1068C15.0198 9.86821 13.205 8.05347 10.9664 8.05347C8.72783 8.05347 6.91309 9.86821 6.91309 12.1068C6.91309 14.3454 8.72783 16.1601 10.9664 16.1601Z"
                    stroke="black"
                    stroke-width="2.02667"
                    stroke-miterlimit="10"
                />
                <path
                    d="M4.16594 29.3336C4.16594 29.3336 4.14567 29.2627 4.13554 29.2222C3.96327 28.6142 3.87207 27.9758 3.87207 27.307C3.87207 23.3854 7.04381 20.2136 10.9654 20.2136C14.887 20.2136 18.0588 23.3854 18.0588 27.307C18.0588 27.9758 17.9675 28.6243 17.7953 29.2323C17.7851 29.2627 17.775 29.3032 17.7649 29.3336"
                    stroke="black"
                    stroke-width="2.02667"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                />
                <path
                    d="M17.8447 17.5075C18.9594 16.3624 20.5199 15.6531 22.2426 15.6531C25.6373 15.6531 28.3935 18.3992 28.3935 21.804C28.3935 21.956 28.3935 22.0979 28.3631 22.2397"
                    stroke="black"
                    stroke-width="2.02667"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                />
                <path
                    d="M22.1129 12.1067C24.3515 12.1067 26.1662 10.2919 26.1662 8.05334C26.1662 5.81474 24.3515 4 22.1129 4C19.8743 4 18.0596 5.81474 18.0596 8.05334C18.0596 10.2919 19.8743 12.1067 22.1129 12.1067Z"
                    stroke="black"
                    stroke-width="2.02667"
                    stroke-miterlimit="10"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-enregistrer'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M27.71 9.29001L22.71 4.29002C22.6165 4.19734 22.5057 4.12401 22.3839 4.07425C22.2621 4.02448 22.1316 3.99926 22 4.00002H6C5.46957 4.00002 4.96086 4.21073 4.58579 4.5858C4.21071 4.96088 4 5.46958 4 6.00002V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V10C28.0007 9.86841 27.9755 9.73794 27.9258 9.61611C27.876 9.49427 27.8027 9.38345 27.71 9.29001ZM12 6.00002H20V10H12V6.00002ZM20 26H12V18H20V26ZM22 26V18C22 17.4696 21.7893 16.9609 21.4142 16.5858C21.0391 16.2107 20.5304 16 20 16H12C11.4696 16 10.9609 16.2107 10.5858 16.5858C10.2107 16.9609 10 17.4696 10 18V26H6V6.00002H10V10C10 10.5304 10.2107 11.0392 10.5858 11.4142C10.9609 11.7893 11.4696 12 12 12H20C20.5304 12 21.0391 11.7893 21.4142 11.4142C21.7893 11.0392 22 10.5304 22 10V6.41001L26 10.41V26H22Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-car'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_309_2237)">
                    <mask id="path-1-inside-1_309_2237" fill="white">
                        <path
                            d="M31.2434 13.6387L22.4068 10.4627L18.7131 5.82495C18.3919 5.43227 17.9874 5.11602 17.5287 4.89917C17.0701 4.68231 16.569 4.57029 16.0617 4.57123H6.92336C6.36446 4.57105 5.81401 4.70758 5.31998 4.96894C4.82596 5.23029 4.40337 5.60853 4.08907 6.07067L0.989627 10.6227C0.344086 11.57 -0.000829458 12.69 -9.03674e-05 13.8364V22.857C-9.03674e-05 23.1601 0.120318 23.4508 0.334646 23.6651C0.548974 23.8795 0.839665 23.9999 1.14277 23.9999H3.59078C3.83939 24.9807 4.40796 25.8507 5.20653 26.4721C6.0051 27.0935 6.98807 27.4309 7.99993 27.4309C9.0118 27.4309 9.99477 27.0935 10.7933 26.4721C11.5919 25.8507 12.1605 24.9807 12.4091 23.9999H19.5908C19.8394 24.9807 20.408 25.8507 21.2066 26.4721C22.0051 27.0935 22.9881 27.4309 24 27.4309C25.0118 27.4309 25.9948 27.0935 26.7934 26.4721C27.592 25.8507 28.1605 24.9807 28.4091 23.9999H30.8571C31.1603 23.9999 31.4509 23.8795 31.6653 23.6651C31.8796 23.4508 32 23.1601 32 22.857V14.7141C32 14.4788 31.9273 14.2492 31.7919 14.0567C31.6565 13.8642 31.4649 13.7182 31.2434 13.6387ZM7.99993 25.1427C7.54786 25.1427 7.10594 25.0087 6.73006 24.7575C6.35417 24.5064 6.0612 24.1494 5.8882 23.7317C5.7152 23.3141 5.66994 22.8545 5.75813 22.4111C5.84633 21.9677 6.06402 21.5604 6.38369 21.2408C6.70335 20.9211 7.11063 20.7034 7.55401 20.6152C7.9974 20.527 8.45698 20.5723 8.87464 20.7453C9.2923 20.9183 9.64928 21.2112 9.90044 21.5871C10.1516 21.963 10.2857 22.4049 10.2857 22.857C10.2847 23.4629 10.0436 24.0438 9.61518 24.4723C9.18672 24.9007 8.60587 25.1418 7.99993 25.1427ZM24 25.1427C23.5479 25.1427 23.106 25.0087 22.7301 24.7575C22.3542 24.5064 22.0613 24.1494 21.8883 23.7317C21.7153 23.3141 21.67 22.8545 21.7582 22.4111C21.8464 21.9677 22.0641 21.5604 22.3837 21.2408C22.7034 20.9211 23.1107 20.7034 23.5541 20.6152C23.9974 20.527 24.457 20.5723 24.8747 20.7453C25.2924 20.9183 25.6493 21.2112 25.9005 21.5871C26.1516 21.963 26.2857 22.4049 26.2857 22.857C26.2851 23.463 26.0441 24.0441 25.6156 24.4726C25.187 24.9011 24.606 25.1421 24 25.1427ZM29.7143 21.7141H28.4091C28.1605 20.7333 27.592 19.8634 26.7934 19.2419C25.9948 18.6205 25.0118 18.2831 24 18.2831C22.9881 18.2831 22.0051 18.6205 21.2066 19.2419C20.408 19.8634 19.8394 20.7333 19.5908 21.7141H12.4091C12.1605 20.7333 11.5919 19.8634 10.7933 19.2419C9.99477 18.6205 9.0118 18.2831 7.99993 18.2831C6.98807 18.2831 6.0051 18.6205 5.20653 19.2419C4.40796 19.8634 3.83939 20.7333 3.59078 21.7141H2.28563V13.8364C2.28551 13.1483 2.49259 12.476 2.87992 11.9073L5.97821 7.35753C6.08298 7.20333 6.22388 7.07711 6.38862 6.98986C6.55336 6.90261 6.73694 6.85698 6.92336 6.85696H16.0617C16.228 6.8563 16.3924 6.8922 16.5433 6.96211C16.6941 7.03202 16.8278 7.13424 16.9348 7.26153L20.8205 12.1404C20.9527 12.3063 21.1284 12.4321 21.328 12.5038L29.7143 15.5176V21.7141Z"
                        />
                    </mask>
                    <path
                        d="M31.2434 13.6387L24.817 31.5189L24.8214 31.5205L31.2434 13.6387ZM22.4068 10.4627L7.54464 22.2997L10.9048 26.5186L15.9804 28.3429L22.4068 10.4627ZM18.7131 5.82495L33.5753 -6.01207L33.4984 -6.10859L33.4203 -6.20411L18.7131 5.82495ZM16.0617 4.57123V23.5712H16.0793L16.097 23.5712L16.0617 4.57123ZM6.92336 4.57123L6.91698 23.5712H6.92336V4.57123ZM4.08907 6.07067L19.7941 16.7642L19.7998 16.7558L4.08907 6.07067ZM0.989627 10.6227L16.6909 21.3217L16.6947 21.3162L0.989627 10.6227ZM-9.03674e-05 13.8364L18.9999 13.8364L18.9999 13.8242L-9.03674e-05 13.8364ZM-9.03674e-05 22.857L-19.0001 22.857L-9.03674e-05 22.857ZM3.59078 23.9999L22.0084 19.3316L18.3757 4.99987L3.59078 4.99987V23.9999ZM12.4091 23.9999V4.99987H-2.37588L-6.0085 19.3316L12.4091 23.9999ZM19.5908 23.9999L38.0084 19.3316L34.3758 4.99987L19.5908 4.99987V23.9999ZM28.4091 23.9999V4.99987H13.6242L9.99155 19.3316L28.4091 23.9999ZM32 14.7141L51 14.7141L51 14.7113L32 14.7141ZM7.99993 25.1427V44.1427H8.01415L8.02837 44.1427L7.99993 25.1427ZM10.2857 22.857L29.2856 22.8854L29.2857 22.8712V22.857H10.2857ZM24 25.1427V44.1427H24.0095L24.019 44.1427L24 25.1427ZM26.2857 22.857L45.2857 22.876L45.2857 22.8665V22.857H26.2857ZM29.7143 21.7141V40.7141H48.7143V21.7141H29.7143ZM28.4091 21.7141L9.99155 26.3824L13.6242 40.7141H28.4091V21.7141ZM19.5908 21.7141V40.7141H34.3758L38.0084 26.3824L19.5908 21.7141ZM12.4091 21.7141L-6.0085 26.3824L-2.37588 40.7141H12.4091V21.7141ZM3.59078 21.7141V40.7141H18.3757L22.0084 26.3824L3.59078 21.7141ZM2.28563 21.7141H-16.7144V40.7141H2.28563V21.7141ZM2.28563 13.8364L21.2856 13.8364L21.2856 13.833L2.28563 13.8364ZM2.87992 11.9073L-12.8245 1.21279L-12.8246 1.21288L2.87992 11.9073ZM5.97821 7.35753L21.6826 18.052L21.6882 18.0438L21.6938 18.0355L5.97821 7.35753ZM6.92336 6.85696L6.92336 -12.143L6.92075 -12.143L6.92336 6.85696ZM16.0617 6.85696V25.857H16.0991L16.1365 25.8568L16.0617 6.85696ZM16.9348 7.26153L31.7971 -4.57538L31.6403 -4.77226L31.4783 -4.96491L16.9348 7.26153ZM20.8205 12.1404L5.95826 23.9773L5.95974 23.9792L20.8205 12.1404ZM21.328 12.5038L27.7535 -5.37666L27.7528 -5.37694L21.328 12.5038ZM29.7143 15.5176H48.7143V2.15583L36.1399 -2.36294L29.7143 15.5176ZM37.6699 -4.2415L28.8333 -7.41751L15.9804 28.3429L24.817 31.5189L37.6699 -4.2415ZM37.269 -1.37434L33.5753 -6.01207L3.85091 17.662L7.54464 22.2997L37.269 -1.37434ZM33.4203 -6.20411C31.3133 -8.78022 28.6592 -10.8548 25.6506 -12.2774L9.40687 22.0758C7.31553 21.0869 5.47057 19.6448 4.00592 17.854L33.4203 -6.20411ZM25.6506 -12.2774C22.642 -13.7 19.3544 -14.4349 16.0264 -14.4287L16.097 23.5712C13.7836 23.5755 11.4982 23.0647 9.40687 22.0758L25.6506 -12.2774ZM16.0617 -14.4288H6.92336V23.5712H16.0617V-14.4288ZM6.92974 -14.4288C3.27157 -14.43 -0.331362 -13.5363 -3.5649 -11.8257L14.2049 21.7635C11.9594 22.9515 9.45736 23.5721 6.91698 23.5712L6.92974 -14.4288ZM-3.5649 -11.8257C-6.79845 -10.115 -9.56444 -7.63932 -11.6217 -4.61446L19.7998 16.7558C18.3712 18.8564 16.4504 20.5756 14.2049 21.7635L-3.5649 -11.8257ZM-11.616 -4.62282L-14.7154 -0.0708066L16.6947 21.3162L19.7941 16.7642L-11.616 -4.62282ZM-14.7117 -0.0763766C-17.5088 4.02851 -19.0033 8.88136 -19.0001 13.8487L18.9999 13.8242C19.0016 16.4987 18.1969 19.1116 16.6909 21.3217L-14.7117 -0.0763766ZM-19.0001 13.8364V22.857H18.9999V13.8364H-19.0001ZM-19.0001 22.857C-19.0001 28.1992 -16.8779 33.3226 -13.1004 37.1002L13.7697 10.2301C17.1186 13.579 18.9999 18.121 18.9999 22.857L-19.0001 22.857ZM-13.1004 37.1002C-9.32286 40.8777 -4.19944 42.9999 1.14277 42.9999V4.99987C5.87877 4.99987 10.4208 6.88123 13.7697 10.2301L-13.1004 37.1002ZM1.14277 42.9999H3.59078V4.99987H1.14277V42.9999ZM-14.8268 28.6681C-13.5397 33.7461 -10.5962 38.2499 -6.46188 41.467L16.8749 11.4771C19.4121 13.4514 21.2185 16.2153 22.0084 19.3316L-14.8268 28.6681ZM-6.46188 41.467C-2.3276 44.6841 2.76138 46.4309 7.99993 46.4309V8.43088C11.2148 8.43088 14.3378 9.50283 16.8749 11.4771L-6.46188 41.467ZM7.99993 46.4309C13.2385 46.4309 18.3275 44.6841 22.4617 41.467L-0.875066 11.4771C1.66208 9.50283 4.78511 8.43088 7.99993 8.43088V46.4309ZM22.4617 41.467C26.596 38.2499 29.5396 33.7461 30.8267 28.6681L-6.0085 19.3316C-5.21862 16.2153 -3.41221 13.4514 -0.875066 11.4771L22.4617 41.467ZM12.4091 42.9999H19.5908V4.99987H12.4091V42.9999ZM1.17324 28.6681C2.46034 33.7461 5.4039 38.2499 9.53817 41.467L32.875 11.4771C35.4121 13.4514 37.2185 16.2153 38.0084 19.3316L1.17324 28.6681ZM9.53817 41.467C13.6725 44.6841 18.7614 46.4309 24 46.4309V8.43088C27.2148 8.43088 30.3378 9.50283 32.875 11.4771L9.53817 41.467ZM24 46.4309C29.2385 46.4309 34.3275 44.6841 38.4618 41.467L15.125 11.4771C17.6621 9.50284 20.7851 8.43088 24 8.43088V46.4309ZM38.4618 41.467C42.5961 38.2499 45.5396 33.7461 46.8267 28.6681L9.99155 19.3316C10.7814 16.2153 12.5878 13.4514 15.125 11.4771L38.4618 41.467ZM28.4091 42.9999H30.8571V4.99987H28.4091V42.9999ZM30.8571 42.9999C36.1994 42.9999 41.3228 40.8777 45.1003 37.1002L18.2302 10.2301C21.5791 6.88123 26.1212 4.99987 30.8571 4.99987V42.9999ZM45.1003 37.1002C48.8779 33.3226 51 28.1991 51 22.857H13C13 18.1211 14.8813 13.5791 18.2302 10.2301L45.1003 37.1002ZM51 22.857V14.7141H13V22.857H51ZM51 14.7113C50.9994 10.5635 49.7183 6.51693 47.3316 3.12437L16.2521 24.989C14.1363 21.9814 13.0005 18.394 13 14.7169L51 14.7113ZM47.3316 3.12437C44.945 -0.26812 41.5692 -2.8411 37.6654 -4.24309L24.8214 31.5205C21.3606 30.2776 18.3679 27.9966 16.2521 24.989L47.3316 3.12437ZM7.99993 6.14273C11.3057 6.14273 14.5373 7.12301 17.2859 8.95959L-3.82578 40.5554C-0.325371 42.8943 3.79 44.1427 7.99993 44.1427V6.14273ZM17.2859 8.95959C20.0345 10.7962 22.1768 13.4066 23.4419 16.4607L-11.6655 31.0027C-10.0544 34.8922 -7.32616 38.2166 -3.82578 40.5554L17.2859 8.95959ZM23.4419 16.4607C24.707 19.5149 25.038 22.8756 24.3931 26.1178L-12.8768 18.7044C-13.6981 22.8334 -13.2766 27.1132 -11.6655 31.0027L23.4419 16.4607ZM24.3931 26.1178C23.7481 29.3601 22.1562 32.3383 19.8187 34.6758L-7.05134 7.80573C-10.0282 10.7826 -12.0555 14.5753 -12.8768 18.7044L24.3931 26.1178ZM19.8187 34.6758C17.4812 37.0133 14.503 38.6052 11.2607 39.2501L3.8473 1.98028C-0.281742 2.8016 -4.07449 4.82887 -7.05134 7.80573L19.8187 34.6758ZM11.2607 39.2501C8.0185 39.895 4.65782 39.5641 1.60366 38.299L16.1456 3.19156C12.2561 1.58048 7.97629 1.15897 3.8473 1.98028L11.2607 39.2501ZM1.60366 38.299C-1.45046 37.0339 -4.06088 34.8916 -5.89748 32.143L25.6984 11.0313C23.3595 7.53086 20.0351 4.80262 16.1456 3.19156L1.60366 38.299ZM-5.89748 32.143C-7.73409 29.3943 -8.71434 26.1627 -8.71434 22.857H29.2857C29.2857 18.6471 28.0373 14.5317 25.6984 11.0313L-5.89748 32.143ZM-8.71432 22.8286C-8.7077 18.4053 -6.94762 14.165 -3.81985 11.0372L23.0502 37.9073C27.0349 33.9226 29.2772 28.5206 29.2856 22.8854L-8.71432 22.8286ZM-3.81985 11.0372C-0.692075 7.90945 3.54819 6.14937 7.9715 6.14275L8.02837 44.1427C13.6635 44.1343 19.0655 41.892 23.0502 37.9073L-3.81985 11.0372ZM24 6.14273C27.3058 6.14273 30.5373 7.123 33.2859 8.95959L12.1743 40.5554C15.6747 42.8943 19.7901 44.1427 24 44.1427V6.14273ZM33.2859 8.95959C36.0346 10.7962 38.1769 13.4066 39.442 16.4607L4.33454 31.0027C5.94561 34.8922 8.67387 38.2165 12.1743 40.5554L33.2859 8.95959ZM39.442 16.4607C40.707 19.5149 41.038 22.8756 40.3931 26.1178L3.12326 18.7044C2.30196 22.8334 2.72346 27.1132 4.33454 31.0027L39.442 16.4607ZM40.3931 26.1178C39.7482 29.3601 38.1563 32.3383 35.8188 34.6758L8.94871 7.80573C5.97186 10.7826 3.94458 14.5753 3.12326 18.7044L40.3931 26.1178ZM35.8188 34.6758C33.4812 37.0133 30.503 38.6052 27.2608 39.2501L19.8473 1.98028C15.7183 2.8016 11.9256 4.82888 8.94871 7.80573L35.8188 34.6758ZM27.2608 39.2501C24.0186 39.895 20.6579 39.5641 17.6037 38.299L32.1457 3.19156C28.2562 1.58048 23.9763 1.15897 19.8473 1.98028L27.2608 39.2501ZM17.6037 38.299C14.5496 37.0339 11.9391 34.8916 10.1026 32.143L41.6984 11.0313C39.3595 7.53089 36.0352 4.80263 32.1457 3.19156L17.6037 38.299ZM10.1026 32.143C8.26598 29.3943 7.28571 26.1628 7.28571 22.857H45.2857C45.2857 18.6471 44.0373 14.5317 41.6984 11.0313L10.1026 32.143ZM7.28572 22.838C7.29013 18.4116 9.05049 14.1676 12.1805 11.0376L39.0506 37.9076C43.0377 33.9205 45.2801 28.5145 45.2857 22.876L7.28572 22.838ZM12.1805 11.0376C15.3106 7.90754 19.5545 6.14716 23.981 6.14274L24.019 44.1427C29.6575 44.1371 35.0635 41.8947 39.0506 37.9076L12.1805 11.0376ZM29.7143 2.71414H28.4091V40.7141H29.7143V2.71414ZM46.8267 17.0459C45.5396 11.9679 42.5961 7.46412 38.4618 4.247L15.125 34.2369C12.5878 32.2626 10.7814 29.4987 9.99155 26.3824L46.8267 17.0459ZM38.4618 4.247C34.3275 1.02988 29.2385 -0.716869 24 -0.716869V37.2831C20.7851 37.2831 17.6621 36.2112 15.125 34.2369L38.4618 4.247ZM24 -0.716869C18.7614 -0.716869 13.6725 1.02988 9.53817 4.247L32.875 34.2369C30.3378 36.2112 27.2148 37.2831 24 37.2831V-0.716869ZM9.53817 4.247C5.40389 7.46412 2.46034 11.9679 1.17324 17.0459L38.0084 26.3824C37.2185 29.4987 35.4121 32.2626 32.875 34.2369L9.53817 4.247ZM19.5908 2.71414H12.4091V40.7141H19.5908V2.71414ZM30.8267 17.0459C29.5396 11.9679 26.596 7.46412 22.4617 4.247L-0.875066 34.2369C-3.41222 32.2626 -5.21863 29.4987 -6.0085 26.3824L30.8267 17.0459ZM22.4617 4.247C18.3275 1.02988 13.2385 -0.716869 7.99993 -0.716869V37.2831C4.78511 37.2831 1.66208 36.2112 -0.875066 34.2369L22.4617 4.247ZM7.99993 -0.716869C2.76138 -0.716869 -2.3276 1.02988 -6.46188 4.247L16.8749 34.2369C14.3378 36.2112 11.2148 37.2831 7.99993 37.2831V-0.716869ZM-6.46188 4.247C-10.5962 7.46412 -13.5397 11.9679 -14.8268 17.0459L22.0084 26.3824C21.2185 29.4987 19.4121 32.2626 16.8749 34.2369L-6.46188 4.247ZM3.59078 2.71414H2.28563V40.7141H3.59078V2.71414ZM21.2856 21.7141V13.8364H-16.7144V21.7141H21.2856ZM21.2856 13.833C21.2862 16.9608 20.3449 20.0163 18.5844 22.6016L-12.8246 1.21288C-15.3597 4.93575 -16.7152 9.33573 -16.7144 13.8398L21.2856 13.833ZM18.5843 22.6017L21.6826 18.052L-9.7262 -3.33693L-12.8245 1.21279L18.5843 22.6017ZM21.6938 18.0355C20.0568 20.4448 17.8553 22.4171 15.2813 23.7803L-2.50405 -9.80063C-5.40756 -8.26286 -7.89085 -6.03816 -9.73739 -3.32047L21.6938 18.0355ZM15.2813 23.7803C12.7072 25.1436 9.83876 25.8566 6.92597 25.857L6.92075 -12.143C3.63512 -12.1426 0.399483 -11.3384 -2.50405 -9.80063L15.2813 23.7803ZM6.92336 25.857H16.0617V-12.143H6.92336V25.857ZM16.1365 25.8568C13.5187 25.8671 10.9306 25.302 8.5554 24.2014L24.5311 -10.2772C21.8541 -11.5176 18.9372 -12.1545 15.9869 -12.1429L16.1365 25.8568ZM8.5554 24.2014C6.18023 23.1009 4.07588 21.4918 2.39129 19.488L31.4783 -4.96491C29.5797 -7.22333 27.208 -9.03685 24.5311 -10.2772L8.5554 24.2014ZM2.07253 19.0984L5.95826 23.9773L35.6828 0.303489L31.7971 -4.57538L2.07253 19.0984ZM5.95974 23.9792C8.28879 26.9027 11.3854 29.1206 14.9032 30.3846L27.7528 -5.37694C30.8714 -4.25639 33.6166 -2.29019 35.6814 0.301633L5.95974 23.9792ZM14.9024 30.3843L23.2887 33.398L36.1399 -2.36294L27.7535 -5.37666L14.9024 30.3843ZM10.7143 15.5176V21.7141H48.7143V15.5176H10.7143Z"
                        fill="black"
                        mask="url(#path-1-inside-1_309_2237)"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_309_2237">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </template>

        <template v-if="icon === 'design-system-statistic'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 5V24C4 24 4 27.5 9.5 27.5H27.5M9.5 16L9.5 23.5M15 23.5V14M20.5 23.5V17M26 23.5V13M9.5 12C10.8333 10.5 13.5 7.33333 15.5 8C17 8.5 19 12 21 11C22.6 10.2 26.3333 6.66667 28 5"
                    stroke="black"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-smartphone'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_309_2239" fill="white">
                    <path
                        d="M18.9167 3H12.4167C10.9806 3.00172 9.60385 3.57296 8.58841 4.5884C7.57296 5.60385 7.00172 6.98061 7 8.41667V23.5833C7.00172 25.0194 7.57296 26.3961 8.58841 27.4116C9.60385 28.427 10.9806 28.9983 12.4167 29H18.9167C20.3527 28.9983 21.7295 28.427 22.7449 27.4116C23.7604 26.3961 24.3316 25.0194 24.3333 23.5833V8.41667C24.3316 6.98061 23.7604 5.60385 22.7449 4.5884C21.7295 3.57296 20.3527 3.00172 18.9167 3ZM12.4167 5.16667H18.9167C19.7786 5.16667 20.6053 5.50908 21.2148 6.11857C21.8243 6.72806 22.1667 7.55471 22.1667 8.41667V20.3333H9.16667V8.41667C9.16667 7.55471 9.50908 6.72806 10.1186 6.11857C10.7281 5.50908 11.5547 5.16667 12.4167 5.16667ZM18.9167 26.8333H12.4167C11.5547 26.8333 10.7281 26.4909 10.1186 25.8814C9.50908 25.2719 9.16667 24.4453 9.16667 23.5833V22.5H22.1667V23.5833C22.1667 24.4453 21.8243 25.2719 21.2148 25.8814C20.6053 26.4909 19.7786 26.8333 18.9167 26.8333Z"
                    />
                    <path
                        d="M15.6667 25.75C16.265 25.75 16.75 25.265 16.75 24.6667C16.75 24.0684 16.265 23.5833 15.6667 23.5833C15.0684 23.5833 14.5833 24.0684 14.5833 24.6667C14.5833 25.265 15.0684 25.75 15.6667 25.75Z"
                    />
                </mask>
                <path
                    d="M18.9167 3L18.9358 -13L18.9262 -13H18.9167V3ZM12.4167 3V-13H12.4071L12.3975 -13L12.4167 3ZM8.58841 4.5884L19.9021 15.9021L19.9021 15.9021L8.58841 4.5884ZM7 8.41667L-8.99999 8.3975L-9 8.40708V8.41667H7ZM7 23.5833H-9V23.5929L-8.99999 23.6025L7 23.5833ZM8.58841 27.4116L19.9021 16.0979L19.9021 16.0979L8.58841 27.4116ZM12.4167 29L12.3975 45L12.4071 45H12.4167V29ZM18.9167 29V45H18.9262L18.9358 45L18.9167 29ZM22.7449 27.4116L11.4312 16.0979L11.4312 16.0979L22.7449 27.4116ZM24.3333 23.5833L40.3333 23.6025L40.3333 23.5929V23.5833H24.3333ZM24.3333 8.41667H40.3333V8.40708L40.3333 8.3975L24.3333 8.41667ZM22.7449 4.5884L11.4312 15.9021L11.4312 15.9021L22.7449 4.5884ZM21.2148 6.11857L9.90104 17.4323L9.90106 17.4323L21.2148 6.11857ZM22.1667 20.3333V36.3333H38.1667V20.3333H22.1667ZM9.16667 20.3333H-6.83333V36.3333H9.16667V20.3333ZM10.1186 6.11857L21.4323 17.4323L21.4323 17.4323L10.1186 6.11857ZM10.1186 25.8814L21.4323 14.5677L21.4323 14.5677L10.1186 25.8814ZM9.16667 22.5V6.5H-6.83333V22.5H9.16667ZM22.1667 22.5H38.1667V6.5H22.1667V22.5ZM21.2148 25.8814L9.90107 14.5677L9.90104 14.5677L21.2148 25.8814ZM18.9167 -13H12.4167V19H18.9167V-13ZM12.3975 -13C6.72462 -12.9932 1.28603 -10.7366 -2.7253 -6.7253L19.9021 15.9021C17.9217 17.8826 15.2366 18.9966 12.4358 19L12.3975 -13ZM-2.7253 -6.7253C-6.73664 -2.71397 -8.99319 2.72462 -8.99999 8.3975L23 8.43583C22.9966 11.2366 21.8825 13.9217 19.9021 15.9021L-2.7253 -6.7253ZM-9 8.41667V23.5833H23V8.41667H-9ZM-8.99999 23.6025C-8.99319 29.2754 -6.73664 34.714 -2.7253 38.7253L19.9021 16.0979C21.8826 18.0783 22.9966 20.7634 23 23.5642L-8.99999 23.6025ZM-2.72531 38.7253C1.28603 42.7366 6.72462 44.9932 12.3975 45L12.4358 13C15.2366 13.0034 17.9217 14.1175 19.9021 16.0979L-2.72531 38.7253ZM12.4167 45H18.9167V13H12.4167V45ZM18.9358 45C24.6087 44.9932 30.0473 42.7366 34.0587 38.7253L11.4312 16.0979C13.4117 14.1174 16.0968 13.0034 18.8975 13L18.9358 45ZM34.0586 38.7253C38.07 34.714 40.3265 29.2754 40.3333 23.6025L8.33335 23.5642C8.3367 20.7634 9.45077 18.0783 11.4312 16.0979L34.0586 38.7253ZM40.3333 23.5833V8.41667H8.33333V23.5833H40.3333ZM40.3333 8.3975C40.3265 2.72463 38.07 -2.71396 34.0586 -6.72531L11.4312 15.9021C9.45077 13.9217 8.3367 11.2366 8.33335 8.43584L40.3333 8.3975ZM34.0586 -6.7253C30.0473 -10.7366 24.6087 -12.9932 18.9358 -13L18.8975 19C16.0968 18.9966 13.4117 17.8826 11.4312 15.9021L34.0586 -6.7253ZM12.4167 21.1667H18.9167V-10.8333H12.4167V21.1667ZM18.9167 21.1667C15.5352 21.1667 12.2921 19.8234 9.90104 17.4323L32.5285 -5.19513C28.9184 -8.80522 24.0221 -10.8333 18.9167 -10.8333V21.1667ZM9.90106 17.4323C7.50997 15.0412 6.16667 11.7982 6.16667 8.41667H38.1667C38.1667 3.31125 36.1385 -1.58507 32.5285 -5.19514L9.90106 17.4323ZM6.16667 8.41667V20.3333H38.1667V8.41667H6.16667ZM22.1667 4.33333H9.16667V36.3333H22.1667V4.33333ZM25.1667 20.3333V8.41667H-6.83333V20.3333H25.1667ZM25.1667 8.41667C25.1667 11.7982 23.8234 15.0412 21.4323 17.4323L-1.19514 -5.19514C-4.80521 -1.58507 -6.83333 3.31125 -6.83333 8.41667H25.1667ZM21.4323 17.4323C19.0412 19.8234 15.7982 21.1667 12.4167 21.1667V-10.8333C7.31125 -10.8333 2.41493 -8.80521 -1.19514 -5.19514L21.4323 17.4323ZM18.9167 10.8333H12.4167V42.8333H18.9167V10.8333ZM12.4167 10.8333C15.7982 10.8333 19.0412 12.1766 21.4323 14.5677L-1.19514 37.1951C2.41494 40.8052 7.31126 42.8333 12.4167 42.8333V10.8333ZM21.4323 14.5677C23.8234 16.9588 25.1667 20.2018 25.1667 23.5833H-6.83333C-6.83333 28.6887 -4.80522 33.5851 -1.19513 37.1952L21.4323 14.5677ZM25.1667 23.5833V22.5H-6.83333V23.5833H25.1667ZM9.16667 38.5H22.1667V6.5H9.16667V38.5ZM6.16667 22.5V23.5833H38.1667V22.5H6.16667ZM6.16667 23.5833C6.16667 20.2018 7.50996 16.9588 9.90107 14.5677L32.5285 37.1952C36.1386 33.5851 38.1667 28.6887 38.1667 23.5833H6.16667ZM9.90104 14.5677C12.2922 12.1766 15.5352 10.8333 18.9167 10.8333V42.8333C24.0221 42.8333 28.9184 40.8052 32.5285 37.1951L9.90104 14.5677ZM15.6667 41.75C25.1015 41.75 32.75 34.1015 32.75 24.6667H0.750001C0.750001 16.4284 7.42842 9.75 15.6667 9.75V41.75ZM32.75 24.6667C32.75 15.2318 25.1015 7.58333 15.6667 7.58333V39.5833C7.42842 39.5833 0.750001 32.9049 0.750001 24.6667H32.75ZM15.6667 7.58333C6.23178 7.58333 -1.41667 15.2318 -1.41667 24.6667H30.5833C30.5833 32.9049 23.9049 39.5833 15.6667 39.5833V7.58333ZM-1.41667 24.6667C-1.41667 34.1015 6.23178 41.75 15.6667 41.75V9.75C23.9049 9.75 30.5833 16.4284 30.5833 24.6667H-1.41667Z"
                    fill="black"
                    mask="url(#path-1-inside-1_309_2239)"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-vocal-message'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 14V18M10 10V22M28 14V18M22 10V22M16 7V26"
                    stroke="#6B7280"
                    stroke-width="2.67"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-add-phone-report'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.9999 7.08551L25.0854 7.08551M25.0854 7.08551L29.171 7.08551M25.0854 7.08551V3M25.0854 7.08551V11.171M4.88889 4C3.2934 4 2 5.2934 2 6.88889V8.33333C2 20.2995 11.7005 30 23.6667 30H25.1111C26.7066 30 28 28.7066 28 27.1111V22.3744C28 21.7527 27.6022 21.2007 27.0123 21.0041L20.5218 18.8406C19.8399 18.6133 19.0946 18.922 18.7731 19.5649L17.1428 22.8254C13.6116 21.2333 10.7667 18.3884 9.17456 14.8572L12.4351 13.2269C13.078 12.9054 13.3867 12.1601 13.1594 11.4782L10.9959 4.98767C10.7993 4.39784 10.2473 4 9.62557 4H4.88889Z"
                    stroke="#262626"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>
        <template v-if="icon === 'design-system-document-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5001 4.00003H8.50022C7.83718 4.00003 7.2013 4.26342 6.73247 4.73226C6.26363 5.20109 6.00024 5.83697 6.00024 6.5V26.4998C6.00024 27.1628 6.26363 27.7987 6.73247 28.2675C7.2013 28.7364 7.83718 28.9998 8.50022 28.9998H23.5001C24.1631 28.9998 24.799 28.7364 25.2678 28.2675C25.7366 27.7987 26 27.1628 26 26.4998V11.4999M18.5001 4.00003L26 11.4999M18.5001 4.00003V11.4999H26M21.0001 17.7499H11.0002M21.0001 22.7498H11.0002M13.5002 12.7499H11.0002"
                    stroke="#262626"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-plus-bold'">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.87499 3V12.75M12.75 7.87499L3 7.87499"
                    stroke="#5567D4"
                    stroke-width="2.196"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>
        <template v-if="icon === 'design-system-origin-job'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.987 18.6351C16.4455 18.6613 15.9041 18.6788 15.3538 18.6788C11.3363 18.67 7.50222 17.8927 4 16.4604C7.72056 17.884 11.7817 18.67 16.0525 18.6788C16.6377 18.6788 17.2141 18.6613 17.7905 18.6351M26.7077 17.1678V9.39482C26.7077 8.43411 25.9304 7.64808 24.9609 7.64808H5.75548C4.78603 7.64808 4 8.43411 4 9.39482V23.5609C4 24.5216 4.78603 25.3077 5.75548 25.3077H16.987M10.3145 7.64808V5.10657C10.3145 3.71791 11.4411 2.59999 12.821 2.59999H17.8953C19.284 2.59999 20.4019 3.72664 20.4019 5.10657V7.64808M13.8953 30.0239L18.6464 25.2727M17.0656 21.3163C17.0656 24.3731 19.546 26.8535 22.6028 26.8535C25.6596 26.8535 28.14 24.3731 28.14 21.3163C28.14 18.2595 25.6596 15.7792 22.6028 15.7792C19.546 15.7792 17.0656 18.2595 17.0656 21.3163Z"
                    stroke="#111827"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>
        <template v-if="icon === 'design-system-star-half-fill'">
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.08565 0.755129C7.4128 -0.25171 8.83721 -0.25171 9.16435 0.75513L10.3332 4.35252C10.4795 4.80279 10.8991 5.10765 11.3726 5.10765H15.1551C16.2137 5.10765 16.6539 6.46234 15.7974 7.0846L12.7373 9.30791C12.3543 9.58619 12.194 10.0795 12.3403 10.5297L13.5092 14.1271C13.8363 15.134 12.6839 15.9712 11.8275 15.3489L8.76735 13.1256C8.38433 12.8474 7.86567 12.8474 7.48265 13.1256L4.42253 15.3489C3.56606 15.9712 2.41369 15.134 2.74083 14.1271L3.90969 10.5297C4.05599 10.0795 3.89572 9.58619 3.5127 9.30791L0.452577 7.0846C-0.403892 6.46234 0.0362751 5.10765 1.09493 5.10765H4.87745C5.35089 5.10765 5.77049 4.80279 5.91679 4.35252L7.08565 0.755129Z"
                    fill="url(#paint0_linear_329_375)"
                />
                <defs>
                    <linearGradient id="paint0_linear_329_375" x1="0.125" y1="8.7813" x2="16.125" y2="8.7813" gradientUnits="userSpaceOnUse">
                        <stop offset="0.505135" stop-color="#6074ED" />
                        <stop offset="0.505235" stop-opacity="0" />
                        <stop offset="0.505335" stop-opacity="0" />
                        <stop offset="0.505435" stop-color="#E9ECFE" />
                    </linearGradient>
                </defs>
            </svg>
        </template>
        <template v-if="icon === 'design-system-cv'">
            <svg width="29" height="36" viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.59261 35.0436H23.6245C25.7211 35.0436 27.4309 33.3339 27.4309 31.2372V12.9916C27.4309 12.4924 27.2312 12.0057 26.8693 11.6438L16.5733 1.34783C16.2114 0.985914 15.7372 0.786235 15.2255 0.786235H4.59261C2.49598 0.786235 0.786235 2.49598 0.786235 4.59261V31.2372C0.786235 33.3339 2.49598 35.0436 4.59261 35.0436Z"
                    fill="#F3F4F6"
                />
                <path
                    d="M4.59261 35.8423C2.05919 35.8423 0 33.7831 0 31.2497V4.59261C0 2.05919 2.05919 0 4.59261 0H15.2255C15.9493 0 16.6233 0.274558 17.1349 0.786235L27.4433 11.0946C27.955 11.6063 28.2296 12.2802 28.2296 13.0041V31.2497C28.2296 33.7831 26.1704 35.8423 23.637 35.8423H4.59261ZM4.59261 1.58495C2.93278 1.58495 1.57247 2.93278 1.57247 4.60509V31.2497C1.57247 32.9096 2.9203 34.2699 4.59261 34.2699H23.6245C25.2843 34.2699 26.6446 32.922 26.6446 31.2497V13.0041C26.6446 12.7046 26.5323 12.43 26.3202 12.2178L16.0117 1.90943C15.7996 1.69727 15.525 1.58495 15.2255 1.58495H4.59261Z"
                    fill="#D1D5DB"
                />
                <path
                    d="M13.4159 19.244H11.5065C11.469 18.9944 11.3942 18.7823 11.2943 18.5826C11.182 18.3829 11.0447 18.2207 10.8825 18.0834C10.7078 17.9461 10.5206 17.8463 10.2959 17.7714C10.0838 17.6965 9.83418 17.6591 9.58458 17.6591C9.12282 17.6591 8.72346 17.7714 8.37403 18.0085C8.02459 18.2332 7.76251 18.5701 7.57531 19.0069C7.38811 19.4437 7.28827 19.9679 7.28827 20.5919C7.28827 21.2159 7.38811 21.765 7.57531 22.2018C7.76251 22.6386 8.03707 22.9631 8.37403 23.1877C8.72346 23.4123 9.11034 23.5247 9.5721 23.5247C9.8217 23.5247 10.0588 23.4872 10.271 23.4248C10.4831 23.3624 10.6828 23.2626 10.8575 23.1378C11.0322 23.013 11.1695 22.8507 11.2818 22.6635C11.3942 22.4763 11.469 22.2642 11.519 22.0271H13.4284C13.3785 22.4514 13.2537 22.8383 13.054 23.2251C12.8543 23.5995 12.5922 23.9365 12.2678 24.2485C11.9433 24.548 11.5439 24.7851 11.0946 24.9598C10.6454 25.1346 10.1212 25.2219 9.54714 25.2219C8.74842 25.2219 8.03707 25.0472 7.41307 24.6853C6.78908 24.3234 6.28988 23.7992 5.92796 23.1128C5.56604 22.4264 5.39133 21.6027 5.39133 20.6293C5.39133 19.6559 5.57852 18.8197 5.94044 18.1458C6.30236 17.4594 6.80156 16.9353 7.43803 16.5858C8.06203 16.2239 8.77338 16.0492 9.55962 16.0492C10.0838 16.0492 10.558 16.1241 10.9948 16.2613C11.4441 16.4111 11.831 16.6233 12.1804 16.8978C12.5298 17.1724 12.8044 17.5093 13.0166 17.9212C13.2287 18.3205 13.3785 18.7823 13.4409 19.3064L13.4159 19.244Z"
                    fill="#6B7281"
                />
                <path
                    d="M16.2613 16.1116L18.4204 22.9007H18.5077L20.6792 16.1116H22.7759L19.6933 25.0597H17.2597L14.1772 16.1116H16.2738H16.2613Z"
                    fill="#6B7281"
                />
            </svg>
        </template>
        <template v-if="icon === 'design-systemp-pencil'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.6596 6.21799L25.7564 11.3148M22.822 4.05559C24.2294 2.64814 26.5114 2.64814 27.9188 4.05559C29.3263 5.46304 29.3263 7.74497 27.9188 9.15243L8.07125 29H3.02563V23.8519L22.822 4.05559Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>
        <template v-if="icon === 'design-system-modification'">
            <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.20117 7.32501V9.95C4.20117 10.5299 4.67127 11 5.25117 11H14.7011C15.281 11 15.7511 10.5299 15.7511 9.95V7.32501"
                    stroke="black"
                    stroke-width="1.875"
                />
                <path d="M9.97461 11.4201V15.0951" stroke="black" stroke-width="1.875" />
                <circle cx="15.6476" cy="4.17499" r="2.73749" stroke="black" stroke-width="1.875" />
                <rect x="1.46484" y="1.4375" width="5.47498" height="5.47498" rx="1.16249" stroke="black" stroke-width="1.875" />
                <circle cx="9.97577" cy="17.825" r="2.73749" stroke="black" stroke-width="1.875" />
            </svg>
        </template>
        <template v-if="icon === 'design-system-line'">
            <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1H15" stroke="#262626" stroke-width="2" stroke-linecap="round" />
            </svg>
        </template>
        <template v-if="icon === 'design-system-arrow-select-down'">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5 4.5L8 11L1.5 4.5" stroke="#262626" stroke-width="1.248" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>
        <template v-if="icon === 'design-system-click-mouse'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.6808 21.6807L18.7531 28.9999L12.8978 12.8977L29 18.753L21.6808 21.6807ZM21.6808 21.6807L29 28.9999M10.2457 3L11.3823 7.24187M7.24187 11.3822L3 10.2456M20.1434 5.65213L17.0381 8.7574M8.75753 17.038L5.65226 20.1432"
                    stroke="#111827"
                    stroke-width="2.496"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>
        <template v-if="icon === 'design-system-git-merge'">
            <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.00482 5.17157C7.75497 4.42143 8.77239 4 9.83325 4C10.8941 4 11.9115 4.42143 12.6617 5.17157C13.4118 5.92172 13.8333 6.93913 13.8333 8C13.8333 9.06087 13.4118 10.0783 12.6617 10.8284C12.2719 11.2182 11.81 11.5192 11.3073 11.7185C11.4889 12.3845 11.8415 12.9984 12.3382 13.4951C13.0883 14.2452 14.1057 14.6667 15.1666 14.6667H19.3953C19.5924 14.1095 19.9123 13.5974 20.3382 13.1716C21.0883 12.4214 22.1057 12 23.1666 12C24.2275 12 25.2449 12.4214 25.995 13.1716C26.7452 13.9217 27.1666 14.9391 27.1666 16C27.1666 17.0609 26.7452 18.0783 25.995 18.8284C25.2449 19.5786 24.2275 20 23.1666 20C22.1057 20 21.0883 19.5786 20.3382 18.8284C19.9123 18.4026 19.5924 17.8905 19.3953 17.3333H15.1666C13.7158 17.3333 12.3138 16.8604 11.1666 16V20.2288C11.7238 20.4258 12.2358 20.7457 12.6617 21.1716C13.4118 21.9217 13.8333 22.9391 13.8333 24C13.8333 25.0609 13.4118 26.0783 12.6617 26.8284C11.9115 27.5786 10.8941 28 9.83325 28C8.77239 28 7.75497 27.5786 7.00482 26.8284C6.25468 26.0783 5.83325 25.0609 5.83325 24C5.83325 22.9391 6.25468 21.9217 7.00482 21.1716C7.4307 20.7457 7.94271 20.4258 8.49992 20.2288V11.7712C7.94271 11.5742 7.4307 11.2543 7.00482 10.8284C6.25468 10.0783 5.83325 9.06087 5.83325 8C5.83325 6.93913 6.25468 5.92172 7.00482 5.17157ZM9.83325 6.66667C9.47963 6.66667 9.14049 6.80714 8.89044 7.05719C8.64039 7.30724 8.49992 7.64638 8.49992 8C8.49992 8.35362 8.64039 8.69276 8.89044 8.94281C9.14049 9.19286 9.47963 9.33333 9.83325 9.33333C10.1869 9.33333 10.526 9.19286 10.7761 8.94281C11.0261 8.69276 11.1666 8.35362 11.1666 8C11.1666 7.64638 11.0261 7.30724 10.7761 7.05719C10.526 6.80714 10.1869 6.66667 9.83325 6.66667ZM23.1666 14.6667C22.813 14.6667 22.4738 14.8071 22.2238 15.0572C21.9737 15.3072 21.8333 15.6464 21.8333 16C21.8333 16.3536 21.9737 16.6928 22.2238 16.9428C22.4738 17.1929 22.813 17.3333 23.1666 17.3333C23.5202 17.3333 23.8593 17.1929 24.1094 16.9428C24.3594 16.6928 24.4999 16.3536 24.4999 16C24.4999 15.6464 24.3594 15.3072 24.1094 15.0572C23.8593 14.8071 23.5202 14.6667 23.1666 14.6667ZM9.83325 22.6667C9.47963 22.6667 9.14049 22.8071 8.89044 23.0572C8.64039 23.3072 8.49992 23.6464 8.49992 24C8.49992 24.3536 8.64039 24.6928 8.89044 24.9428C9.14049 25.1929 9.47963 25.3333 9.83325 25.3333C10.1869 25.3333 10.526 25.1929 10.7761 24.9428C11.0261 24.6928 11.1666 24.3536 11.1666 24C11.1666 23.6464 11.0261 23.3072 10.7761 23.0572C10.526 22.8071 10.1869 22.6667 9.83325 22.6667Z"
                    fill="white"
                />
            </svg>
        </template>
        <template v-if="icon === 'design-system-exclamation-mark'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 4C12.5523 4 13 4.44772 13 5V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V5C11 4.44772 11.4477 4 12 4ZM12 18C12.5523 18 13 18.4477 13 19V19.01C13 19.5623 12.5523 20.01 12 20.01C11.4477 20.01 11 19.5623 11 19.01V19C11 18.4477 11.4477 18 12 18Z"
                    fill="#00061A"
                />
            </svg>
        </template>
    </div>
</template>
<style lang="scss">
.NewIcon {
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        margin: 0;
        padding: 0;
        width: 18px;
        height: 18px;
    }
}
</style>
